import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
  MenuItem,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PrintIcon from "@mui/icons-material/Print";
import SaveIcon from "@mui/icons-material/Save";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
} from "firebase/firestore";
import {
  Line,
  ReferenceDot,
  ReferenceLine,
  LineChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip as ChartTooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useHistory, useParams } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import CabecalhoDetalhes from "../Components/CabecalhoDetalhes/CabecalhoDetalhes";
import { db, auth } from "../Config/firebase";
import {
  COLLECTION_CAPSULAS,
  COLLECTION_CILINDROS,
  COLLECTION_COMPACTACAO,
  COLLECTION_FAIXAS_DNIT,
  criarCBR,
  criarExpansao,
  criarGranulometria,
  criarLimites,
  criarPontosCompactacao,
  criarSubstituicaoSolo,
  estadoInicialCompactacao,
  faixasDnitPadrao,
  numero,
  penetracoesCBR,
  recalcularResultados,
  sincronizarDatasExpansao,
} from "./compactacaoModel";
import RelatorioCompactacaoPrint from "./RelatorioCompactacaoPrint";
import { consultaTenantAtual , aplicarTenantAtual} from "../Utils/tenant";
import {
  atualizarDocumentoComMesclagem,
  extrairCamposAlterados,
} from "../Utils/concorrenciaFirestore";

const cellSx = {
  textAlign: "center",
  verticalAlign: "middle",
  px: "6px",
  py: "5px",
  fontSize: 12,
  color: "#334155",
  borderColor: "#d7dde8",
};

function formatarDataCabecalho(valor) {
  if (!valor) return "-";
  const data = valor?.toDate?.() || new Date(/^\d{4}-\d{2}-\d{2}$/.test(String(valor)) ? `${valor}T00:00:00` : valor);
  return Number.isNaN(data.getTime()) ? "-" : data.toLocaleDateString("pt-BR");
}

const capsulasLimiteLiquidezPadrao = [
  ["01", "6,61"], ["02", "6,58"], ["03", "6,61"], ["04", "6,50"],
  ["05", "6,62"], ["06", "6,56"], ["07", "6,54"], ["08", "6,39"],
  ["09", "6,53"], ["10", "6,59"], ["11", "9,23"], ["12", "9,22"],
  ["13", "9,11"], ["14", "8,92"], ["15", "9,03"], ["16", "9,04"],
  ["17", "8,78"], ["18", "9,09"], ["19", "9,17"], ["20", "9,19"],
  ["21", "6,02"], ["22", "12,18"], ["23", "6,23"], ["24", "5,70"],
  ["25", "5,75"], ["26", "5,77"], ["27", "5,52"], ["28", "5,81"],
  ["29", "5,66"], ["30", "5,56"], ["31", "5,75"], ["32", "5,95"],
  ["33", "6,06"], ["34", "6,59"], ["35", "6,84"], ["36", "5,70"],
  ["37", "5,89"], ["38", "6,20"], ["39", "6,06"], ["40", "5,69"],
  ["41", "6,09"], ["42", "5,70"], ["43", "6,08"], ["44", "5,81"],
  ["45", "5,81"], ["46", "6,25"], ["47", "5,60"], ["48", "6,25"],
  ["49", "5,37"], ["50", "5,97"],
].map(([numeroCapsula, pesoCapsula]) => ({
  numero: numeroCapsula,
  tipo: "limite_liquidez",
  pesoCapsula,
}));

const tampasLimitePlasticidadePadrao = [
  ["01", "4,70"], ["02", "4,92"], ["03", "4,85"], ["04", "4,97"],
  ["05", "4,42"], ["06", "4,59"], ["07", "4,81"], ["08", "4,57"],
  ["09", "4,82"], ["10", "4,79"], ["11", "4,93"], ["12", "5,10"],
  ["13", "4,64"], ["14", "5,07"], ["15", "5,10"], ["16", "4,59"],
  ["17", "5,20"], ["18", "5,18"], ["19", "5,18"], ["20", "5,02"],
  ["21", "3,78"], ["22", "8,75"], ["23", "3,46"], ["24", "4,09"],
  ["25", "3,70"], ["26", "4,06"], ["27", "3,96"], ["28", "4,24"],
  ["29", "3,72"], ["30", "3,58"], ["31", "3,73"], ["32", "3,87"],
  ["33", "3,65"], ["34", "3,91"], ["35", "3,81"], ["36", "4,92"],
  ["37", "3,68"], ["38", "3,90"], ["39", "3,77"], ["40", "3,73"],
  ["41", "3,69"], ["42", "3,86"], ["43", "3,45"], ["44", "3,72"],
  ["45", "3,71"], ["46", "3,79"], ["47", "3,68"], ["48", "4,50"],
  ["49", "3,80"], ["50", "3,88"],
].map(([numeroCapsula, pesoTampa]) => ({
  numero: numeroCapsula,
  tipo: "limite_plasticidade",
  pesoTampa,
}));

function campoTabela(valor, onChange, props = {}) {
  const {
    inputProps: inputPropsRecebido = {},
    onKeyDown: onKeyDownRecebido,
    onBlur: onBlurRecebido,
    salvarAoSair = false,
    ...restProps
  } = props;

  const propsValor = salvarAoSair
    ? {
        defaultValue: valor ?? "",
        onBlur: (event) => {
          onChange(event.target.value);
          onBlurRecebido?.(event);
        },
      }
    : {
        value: valor ?? "",
        onChange: (event) => onChange(event.target.value),
        onBlur: onBlurRecebido,
      };

  return (
    <TextField
      key={salvarAoSair ? String(valor ?? "") : undefined}
      {...restProps}
      {...propsValor}
      variant="outlined"
      size="small"
      fullWidth
      inputProps={{
        autoComplete: "off",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: "false",
  inputMode: "decimal",
  pattern: "[0-9,]*",
onInput: (event) => {
  event.target.value = event.target.value.replace(/[^0-9,]/g, "");
},
        ...inputPropsRecebido,
        "data-enter-row": inputPropsRecebido["data-enter-row"],
        "data-enter-col": inputPropsRecebido["data-enter-col"],
        onKeyDown: (event) => {
          inputPropsRecebido?.onKeyDown?.(event);
          onKeyDownRecebido?.(event);

          if (event.defaultPrevented) return;
          if (event.key !== "Enter") return;

          event.preventDefault();
          event.stopPropagation();

          const inputAtual = event.currentTarget;
          const row = Number(inputAtual.dataset.enterRow);
          const col = inputAtual.dataset.enterCol;

          if (!Number.isFinite(row) || !col) {
            const celulaAtual = inputAtual.closest("td");
            let linhaSeguinte = celulaAtual?.closest("tr")?.nextElementSibling;
            const indiceCelula = celulaAtual?.cellIndex;

            while (linhaSeguinte && Number.isInteger(indiceCelula)) {
              const inputAbaixo = linhaSeguinte.cells?.[indiceCelula]?.querySelector("input:not([disabled])");
              if (inputAbaixo) {
                inputAbaixo.focus();
                inputAbaixo.select?.();
                return;
              }
              linhaSeguinte = linhaSeguinte.nextElementSibling;
            }
            return;
          }

          const proximoInput = document.querySelector(
            `input[data-enter-row="${row + 1}"][data-enter-col="${col}"]`
          );

          if (proximoInput) {
            proximoInput.focus();
            proximoInput.select?.();
          }
        },
        style: {
          textAlign: "center",
          fontSize: 12,
          padding: "5px 4px",
          height: 18,
          ...(inputPropsRecebido.style || {}),
        },
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: 30,
          backgroundColor: "#fff",
          borderRadius: "4px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#cfd8e3",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#94a3b8",
        },
        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#1976d2",
        },
      }}
    />
  );
}

function graficoVazio(texto) {
  return (
    <Box
      sx={{
        height: 260,
        display: "grid",
        placeItems: "center",
        color: "text.secondary",
        border: "1px dashed #cbd5e1",
      }}
    >
      {texto}
    </Box>
  );
}

function normalizarNumero(valor) {
  const apenasNumeros = String(valor || "").replace(/\D/g, "");
  if (!apenasNumeros) return "";
  return String(parseInt(apenasNumeros, 10));
}

function buscarCilindroPorNumero(lista, valor) {
  const numeroDigitado = normalizarNumero(valor);
  if (!numeroDigitado) return null;

  return (
    lista.find((cilindro) => {
      const numeroBanco = normalizarNumero(
        cilindro.numero ||
          cilindro.numeroCilindro ||
          cilindro.codigo ||
          cilindro.id
      );

      return numeroBanco === numeroDigitado;
    }) || null
  );
}

function buscarCapsulaPorNumero(lista, valor, tipo = "higroscopica") {
  const numeroDigitado = normalizarNumero(valor);
  if (!numeroDigitado) return null;

  const tiposHigroscopica = [
    "higroscopica",
    "higroscópica",
    "umidade_higroscopica",
    "umidade higroscopica",
    "umidade higroscópica",
    "capsula",
    "cápsula",
  ];

  return (
    lista.find((capsula) => {
      const numeroBanco = normalizarNumero(
        capsula.numero ||
          capsula.numeroCapsula ||
          capsula.codigo ||
          capsula.id
      );

      const tipoBanco = String(
        capsula.tipo || capsula.categoria || capsula.grupo || ""
      )
        .toLowerCase()
        .trim();

      const tipoOk =
        !tipo ||
        tipoBanco === tipo ||
        tiposHigroscopica.includes(tipoBanco) ||
        tipoBanco === "";

      return numeroBanco === numeroDigitado && tipoOk;
    }) || null
  );
}

function obterPesoCapsula(capsula) {
  if (!capsula) return "";

  return (
    capsula.pesoCapsula ||
    capsula.pesoCapsulaVazia ||
    capsula.peso ||
    capsula.massa ||
    capsula.massaCapsula ||
    capsula.massaCapsulaVazia ||
    capsula.pesoTampa ||
    ""
  );
}

function obterPesoCilindro(cilindro) {
  if (!cilindro) return "";

  const peso =
    cilindro.peso ||
    cilindro.massa ||
    cilindro.massaCilindro ||
    cilindro.pesoCilindro ||
    cilindro.pesoMolde ||
    "";

  const n = numeroPesoMaterial(peso);

  return n !== null ? formatarInteiroPt(n) : peso;
}

function obterVolumeCilindro(cilindro) {
  if (!cilindro) return "";

  return (
    cilindro.volume ||
    cilindro.volumeCilindro ||
    cilindro.volumeMolde ||
    ""
  );
}

function obterAlturaCilindro(cilindro) {
  if (!cilindro) return "";

  return (
    cilindro.altura ||
    cilindro.alturaCilindro ||
    cilindro.alturaCp ||
    cilindro.alturaCP ||
    ""
  );
}

function numeroDecimal(valor) {
  if (valor === null || valor === undefined || valor === "") return null;

  const texto = String(valor).trim();
  if (!texto) return null;

  let normalizado = texto.replace(/\s/g, "");

  if (normalizado.includes(",") && normalizado.includes(".")) {
    normalizado = normalizado.replace(/\./g, "").replace(",", ".");
  } else {
    normalizado = normalizado.replace(",", ".");
  }

  const n = Number(normalizado);
  return Number.isFinite(n) ? n : null;
}

function calcularSubstituicaoSolo(dados = {}) {
  const retidoTresQuartos = numeroDecimal(dados.pesoRetidoTresQuartos) || 0;
  const retidoNumero4 = numeroDecimal(dados.pesoRetidoNumero4) || 0;
  const passanteNumero4 = numeroDecimal(dados.pesoPassanteNumero4) || 0;
  const amostraTotal = retidoTresQuartos + retidoNumero4 + passanteNumero4;
  const pesoCompactacao = numeroDecimal(dados.pesoAmostraCompactacao) || 0;
  const pesoGranulometria = numeroDecimal(dados.pesoAmostraGranulometria) || 0;
  const percentual = (peso) => (amostraTotal > 0 ? (peso / amostraTotal) * 100 : 0);
  const arredondarPercentual = (valor) => Math.round((valor + Number.EPSILON) * 10) / 10;
  const percentuaisBrutos = [
    percentual(retidoTresQuartos),
    percentual(retidoNumero4),
    percentual(passanteNumero4),
  ];
  const percentuaisArredondados = percentuaisBrutos.map(arredondarPercentual);

  if (amostraTotal > 0) {
    const diferenca = arredondarPercentual(
      100 - percentuaisArredondados.reduce((soma, valor) => soma + valor, 0)
    );
    const indiceMaiorFracao = percentuaisBrutos.indexOf(Math.max(...percentuaisBrutos));
    percentuaisArredondados[indiceMaiorFracao] = arredondarPercentual(
      percentuaisArredondados[indiceMaiorFracao] + diferenca
    );
  }

  const [percentualTresQuartos, percentualNumero4, percentualPassanteNumero4] =
    percentuaisArredondados;
  const percentualRetidoTotal = arredondarPercentual(
    percentualTresQuartos + percentualNumero4
  );
  const pesoCompactacaoArredondado = Math.round(pesoCompactacao);
  const compactacaoRetidos = Math.round(
    pesoCompactacaoArredondado * percentualRetidoTotal / 100
  );
  const compactacaoPassante = pesoCompactacaoArredondado - compactacaoRetidos;
  const arredondarPesoGranulometria = (valor) =>
    Math.round((valor + Number.EPSILON) * 10) / 10;
  const pesoGranulometriaArredondado = arredondarPesoGranulometria(pesoGranulometria);
  const granulometriaTresQuartos = arredondarPesoGranulometria(
    pesoGranulometriaArredondado * percentualTresQuartos / 100
  );
  const granulometriaNumero4 = arredondarPesoGranulometria(
    pesoGranulometriaArredondado * percentualNumero4 / 100
  );
  const granulometriaPassante = arredondarPesoGranulometria(
    pesoGranulometriaArredondado - granulometriaTresQuartos - granulometriaNumero4
  );

  return {
    amostraTotal,
    percentualTresQuartos,
    percentualNumero4,
    percentualPassanteNumero4,
    percentualRetidoTotal,
    compactacaoRetidos,
    compactacaoPassante,
    granulometriaTresQuartos,
    granulometriaNumero4,
    granulometriaPassante,
  };
}

function formatarCalculo(valor, casas = 2) {
  if (!Number.isFinite(valor)) return "-";
  return valor.toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

function numeroPesoMaterial(valor) {
  if (valor === null || valor === undefined || valor === "") return null;

  const texto = String(valor).trim();
  if (!texto) return null;

  let normalizado = texto.replace(/\s/g, "");

  // Exemplo: 8.800,5 => 8800.5
  if (normalizado.includes(".") && normalizado.includes(",")) {
    normalizado = normalizado.replace(/\./g, "").replace(",", ".");
  }
  // Exemplo: 8.800 => 8800
  else if (/^\d{1,3}(\.\d{3})+$/.test(normalizado)) {
    normalizado = normalizado.replace(/\./g, "");
  }
  // Exemplo: 8800,5 => 8800.5
  else {
    normalizado = normalizado.replace(",", ".");
  }

  const n = Number(normalizado);
  return Number.isFinite(n) ? n : null;
}

function temTresCasasDecimais(valor) {
  return /^\d+(?:[,.]\d{3})$/.test(String(valor || "").trim());
}

function arred(valor, casas = 2) {
  if (valor === null || valor === undefined || !Number.isFinite(valor)) {
    return null;
  }

  const fator = 10 ** casas;
  return Math.round((valor + Number.EPSILON) * fator) / fator;
}

function formatarDecimal(valor, casas = 2) {
  if (valor === null || valor === undefined || valor === "") return "";

  const n = typeof valor === "number" ? valor : numeroDecimal(valor);
  if (n === null) return "";

  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

function formatarInteiroPt(valor) {
  if (valor === null || valor === undefined || valor === "") return "";

  const n = typeof valor === "number" ? valor : numeroPesoMaterial(valor);
  if (n === null) return "";

  return Math.round(n).toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

function calcularTicksDensidade(dados = [], valorExtra = null) {
  const valores = dados
    .map((item) => numeroDecimal(item.densidadeSeca))
    .filter((valor) => valor !== null);

  const extra = numeroDecimal(valorExtra);
  if (extra !== null) valores.push(extra);

  if (!valores.length) {
    return { domain: [1.4, 1.8], ticks: [1.4, 1.45, 1.5, 1.55, 1.6, 1.65, 1.7, 1.75, 1.8] };
  }

  const minimo = Math.floor((Math.min(...valores) - 0.05) / 0.05) * 0.05;
  const maximo = Math.ceil((Math.max(...valores) + 0.05) / 0.05) * 0.05;
  const ticks = [];

  for (let valor = minimo; valor <= maximo + 0.000001; valor += 0.05) {
    ticks.push(Number(valor.toFixed(3)));
  }

  return {
    domain: [Number(minimo.toFixed(3)), Number(maximo.toFixed(3))],
    ticks,
  };
}

function calcularDominioUmidade(dados = [], valorExtra = null) {
  const valores = dados
    .map((item) => numeroDecimal(item.umidade))
    .filter((valor) => valor !== null);

  const extra = numeroDecimal(valorExtra);
  if (extra !== null) valores.push(extra);

  if (!valores.length) return [0, 100];

  const minimo = Math.floor(Math.min(...valores) - 1);
  const maximo = Math.ceil(Math.max(...valores) + 1);

  return [minimo, maximo];
}

function criarTicksIntervalo(inicio, fim, passo) {
  const ticks = [];
  const primeiro = Math.ceil(inicio / passo) * passo;

  for (let valor = primeiro; valor <= fim + 0.000001; valor += passo) {
    ticks.push(Number(valor.toFixed(6)));
  }

  return ticks;
}

function criarEscalaBanda(valores = [], inicio = 0, fim = 100, passo = 1) {
  const validos = valores.filter((valor) => valor !== null && Number.isFinite(valor));
  const maximoReal = validos.length ? Math.max(...validos) : 1;
  const minimoReal = 0;
  let maximo = Math.ceil(maximoReal / passo) * passo;
  if (maximo <= maximoReal) maximo += passo;
  if (maximo <= 0) maximo = passo;
  const amplitude = maximo - minimoReal || 1;

  const toPlot = (valor) =>
    valor === null || valor === undefined
      ? null
      : inicio + ((valor - minimoReal) / amplitude) * (fim - inicio);

  const fromPlot = (valor) =>
    minimoReal + ((valor - inicio) / (fim - inicio)) * amplitude;

  return {
    domain: [0, 100],
    ticks: criarTicksIntervalo(minimoReal, maximo, passo).map(toPlot),
    toPlot,
    fromPlot,
  };
}

function mesmoPontoPenetracao(valor, alvo) {
  return numeroDecimal(valor) === alvo;
}

function calcularPressaoCbr(leitura, ensaio = {}) {
  const valorLeitura = numeroDecimal(leitura);
  if (valorLeitura === null) return null;

  const tipo = ensaio.tipoMedicaoCbr || "anel";
  if (tipo === "anel") {
    const constante = numeroDecimal(ensaio.constanteAnelCbr);
    return constante !== null ? valorLeitura * constante : null;
  }

  const areaPistao = numeroDecimal(ensaio.areaPistaoCbr || "19,35");
  return areaPistao ? valorLeitura / areaPistao : null;
}

function temLeituraExpansao(valor) {
  return String(valor ?? "").trim() !== "";
}

function estimarDeslocamentoCorrecaoCbr(leituras = []) {
  return criarModeloCorrecaoCbr(leituras)?.deslocamentoAutomatico ?? null;
}

function gerarLinhaTendenciaVisualCbr(pontos = [], amostras = 100) {
  const dados = pontos
    .filter(
      ponto => ponto.penetracao !== null && ponto.pressao !== null
    )
    .sort((a, b) => a.penetracao - b.penetracao);
  if (dados.length < 3) return dados;

  const grau = Math.min(4, dados.length - 1);
  const matriz = [];
  const vetor = [];

  for (let linha = 0; linha <= grau; linha += 1) {
    matriz[linha] = [];
    for (let coluna = 0; coluna <= grau; coluna += 1) {
      matriz[linha][coluna] = dados.reduce(
        (soma, ponto) =>
          soma + Math.pow(ponto.penetracao, linha + coluna),
        0
      );
    }
    vetor[linha] = dados.reduce(
      (soma, ponto) =>
        soma + ponto.pressao * Math.pow(ponto.penetracao, linha),
      0
    );
  }

  for (let linha = 0; linha <= grau; linha += 1) {
    let maiorPivo = linha;
    for (let candidata = linha + 1; candidata <= grau; candidata += 1) {
      if (
        Math.abs(matriz[candidata][linha]) >
        Math.abs(matriz[maiorPivo][linha])
      ) {
        maiorPivo = candidata;
      }
    }

    [matriz[linha], matriz[maiorPivo]] = [
      matriz[maiorPivo],
      matriz[linha],
    ];
    [vetor[linha], vetor[maiorPivo]] = [
      vetor[maiorPivo],
      vetor[linha],
    ];

    const divisor = matriz[linha][linha] || 1;
    for (let coluna = linha; coluna <= grau; coluna += 1) {
      matriz[linha][coluna] /= divisor;
    }
    vetor[linha] /= divisor;

    for (let outraLinha = 0; outraLinha <= grau; outraLinha += 1) {
      if (outraLinha === linha) continue;
      const fator = matriz[outraLinha][linha];
      for (let coluna = linha; coluna <= grau; coluna += 1) {
        matriz[outraLinha][coluna] -= fator * matriz[linha][coluna];
      }
      vetor[outraLinha] -= fator * vetor[linha];
    }
  }

  const inicio = dados[0].penetracao;
  const fim = dados[dados.length - 1].penetracao;

  return Array.from({ length: amostras + 1 }, (_, index) => {
    const penetracao = inicio + ((fim - inicio) * index) / amostras;
    const pressao = vetor.reduce(
      (soma, coeficiente, expoente) =>
        soma + coeficiente * Math.pow(penetracao, expoente),
      0
    );
    return { penetracao, pressao };
  });
}

function interpolarPressaoCbr(leituras = [], penetracaoAlvo) {
  const pontos = leituras
    .map(item => ({
      penetracao: numeroDecimal(item.mm ?? item.penetracao),
      pressao: numeroDecimal(item.pressao),
    }))
    .filter(
      ponto => ponto.penetracao !== null && ponto.pressao !== null
    )
    .sort((a, b) => a.penetracao - b.penetracao);

  const exato = pontos.find(
    ponto => Math.abs(ponto.penetracao - penetracaoAlvo) < 0.0001
  );
  if (exato) return exato.pressao;

  for (let index = 0; index < pontos.length - 1; index += 1) {
    const atual = pontos[index];
    const proximo = pontos[index + 1];
    if (
      penetracaoAlvo > atual.penetracao &&
      penetracaoAlvo < proximo.penetracao
    ) {
      const proporcao =
        (penetracaoAlvo - atual.penetracao) /
        (proximo.penetracao - atual.penetracao);
      return atual.pressao + (proximo.pressao - atual.pressao) * proporcao;
    }
  }

  return null;
}

function criarModeloCorrecaoCbr(leituras = [], deslocamentoInformado = null) {
  const pontos = [
    { penetracao: 0, pressao: 0 },
    ...leituras
      .map(item => ({
        penetracao: numeroDecimal(item.mm),
        pressao: numeroDecimal(item.pressao),
      }))
      .filter(
        ponto => ponto.penetracao !== null && ponto.pressao !== null
      ),
  ].sort((a, b) => a.penetracao - b.penetracao);
  if (pontos.length < 3) return null;

  let segmentoTangente = null;

  for (let index = 0; index < pontos.length - 1; index += 1) {
    const atual = pontos[index];
    const proximo = pontos[index + 1];
    if (proximo.penetracao > 5.08) break;

    const intervalo = proximo.penetracao - atual.penetracao;
    if (intervalo <= 0) continue;
    const inclinacao = (proximo.pressao - atual.pressao) / intervalo;

    if (
      inclinacao > 0 &&
      (!segmentoTangente || inclinacao > segmentoTangente.inclinacao)
    ) {
      segmentoTangente = { atual, proximo, inclinacao };
    }
  }

  if (!segmentoTangente) return null;

  const pontoInflexao = {
    penetracao:
      (segmentoTangente.atual.penetracao +
        segmentoTangente.proximo.penetracao) /
      2,
    pressao:
      (segmentoTangente.atual.pressao +
        segmentoTangente.proximo.pressao) /
      2,
    inclinacao: segmentoTangente.inclinacao,
  };

  const deslocamentoAutomatico =
    pontoInflexao.penetracao -
    pontoInflexao.pressao / pontoInflexao.inclinacao;
  if (!(deslocamentoAutomatico > 0.05)) return null;

  const deslocamentoManual = numeroDecimal(deslocamentoInformado);
  const deslocamento =
    deslocamentoManual !== null && deslocamentoManual > 0
      ? deslocamentoManual
      : deslocamentoAutomatico;
  const penetracaoTangencia = pontoInflexao.penetracao - deslocamento;
  if (!(penetracaoTangencia > 0)) return null;

  return {
    deslocamento,
    deslocamentoAutomatico,
    pontoInflexao,
    penetracaoTangencia,
    calcularPressaoCorrigida(penetracao) {
      if (penetracao === null) return null;
      return interpolarPressaoCbr(
        leituras,
        penetracao + deslocamento
      );
    },
  };
}

function calcularLinhaCbrLocal(linha = {}, ensaio = {}) {
  const leiturasCalculadas = penetracoesCBR.map((ponto, index) => {
    const leitura = linha.leituras?.[index] || {};
    const pressao = calcularPressaoCbr(leitura.leitura, ensaio);

    return {
      ...leitura,
      mm: ponto.mm,
      tempo: ponto.tempo,
      pressao: pressao !== null ? formatarDecimal(arred(pressao, 1), 1) : "",
    };
  });

  const deslocamentoCorrecao = numeroDecimal(linha.correcaoCbrMm);
  const aplicarCorrecao =
    linha.aplicarCorrecao === true &&
    deslocamentoCorrecao !== null &&
    deslocamentoCorrecao > 0;
  const modeloCorrecao = aplicarCorrecao
    ? criarModeloCorrecaoCbr(leiturasCalculadas, deslocamentoCorrecao)
    : null;
  const leituras = leiturasCalculadas.map(item => {
    const penetracao = numeroDecimal(item.mm);
    const pontoDeCorrecao =
      mesmoPontoPenetracao(penetracao, 2.54) ||
      mesmoPontoPenetracao(penetracao, 5.08);
    const pressaoCorrigida =
      modeloCorrecao && penetracao !== null && pontoDeCorrecao
        ? modeloCorrecao.calcularPressaoCorrigida(penetracao)
        : null;

    return {
      ...item,
      correcao:
        pressaoCorrigida !== null
          ? formatarDecimal(arred(pressaoCorrigida, 1), 1)
          : "",
    };
  });

  const pressao254 = numeroDecimal(
    leituras.find((item) => mesmoPontoPenetracao(item.mm, 2.54))?.[
      aplicarCorrecao ? "correcao" : "pressao"
    ]
  );
  const pressao508 = numeroDecimal(
    leituras.find((item) => mesmoPontoPenetracao(item.mm, 5.08))?.[
      aplicarCorrecao ? "correcao" : "pressao"
    ]
  );
  const isc254 = pressao254 !== null ? (pressao254 / 70.31) * 100 : null;
  const isc508 = pressao508 !== null ? (pressao508 / 105.46) * 100 : null;
  const isc = [isc254, isc508].filter((valor) => valor !== null);

  return {
    ...linha,
    leituras,
    correcaoCbrInflexaoMm: modeloCorrecao
      ? modeloCorrecao.pontoInflexao.penetracao
      : "",
    correcaoCbrInflexaoPressao: modeloCorrecao
      ? modeloCorrecao.pontoInflexao.pressao
      : "",
    isc254: isc254 !== null ? formatarDecimal(arred(isc254, 1), 1) : "",
    isc508: isc508 !== null ? formatarDecimal(arred(isc508, 1), 1) : "",
    isc: isc.length ? formatarDecimal(arred(Math.max(...isc), 1), 1) : "",
  };
}

function selecionarCampoIsc(cbr = []) {
  const valores254 = cbr
    .map((linha) => numeroDecimal(linha.isc254))
    .filter((valor) => valor !== null);
  const valores508 = cbr
    .map((linha) => numeroDecimal(linha.isc508))
    .filter((valor) => valor !== null);
  const maior254 = valores254.length ? Math.max(...valores254) : null;
  const maior508 = valores508.length ? Math.max(...valores508) : null;

  return maior508 !== null && (maior254 === null || maior508 > maior254)
    ? "isc508"
    : "isc254";
}

function interpolarValorPorUmidade(pontos = [], umidadeOtima) {
  if (umidadeOtima === null || umidadeOtima === undefined) return null;

  const validos = pontos
    .filter((ponto) => ponto.x !== null && ponto.y !== null)
    .sort((a, b) => a.x - b.x);

  if (!validos.length) return null;

  const exato = validos.find((ponto) => ponto.x === umidadeOtima);
  if (exato) return exato.y;

  for (let index = 0; index < validos.length - 1; index += 1) {
    const atual = validos[index];
    const proximo = validos[index + 1];
    if (umidadeOtima >= atual.x && umidadeOtima <= proximo.x) {
      const proporcao = (umidadeOtima - atual.x) / (proximo.x - atual.x || 1);
      return atual.y + (proximo.y - atual.y) * proporcao;
    }
  }

  return null;
}

function calcularIscFinal(ensaio = {}) {
  const campoIsc = selecionarCampoIsc(ensaio.cbr || []);
  const umidadeOtima = numeroDecimal(ensaio.resultados?.umidadeOtima);
  const pontos = (ensaio.cbr || [])
    .map((linha, index) => ({
      x: numeroDecimal(ensaio.compactacao?.[index]?.umidadeCalculada || ensaio.compactacao?.[index]?.umidade),
      y: numeroDecimal(linha[campoIsc]),
    }))
    .filter((ponto) => ponto.x !== null && ponto.y !== null);
  const iscInterpolado = interpolarValorPorUmidade(pontos, umidadeOtima);

  return iscInterpolado !== null ? formatarDecimal(arred(iscInterpolado, 1), 1) : ensaio.resultados?.isc || "";
}

function calcularExpansaoFinal(ensaio = {}) {
  const umidadeOtima = numeroDecimal(ensaio.resultados?.umidadeOtima);
  const pontos = (ensaio.expansao || [])
    .map((linha, index) => ({
      x: numeroDecimal(ensaio.compactacao?.[index]?.umidadeCalculada || ensaio.compactacao?.[index]?.umidade),
      y: numeroDecimal(linha.expansao),
    }))
    .filter((ponto) => ponto.x !== null && ponto.y !== null);
  const expansaoInterpolada = interpolarValorPorUmidade(pontos, umidadeOtima);

  return expansaoInterpolada !== null
    ? formatarDecimal(arred(expansaoInterpolada, 2), 2)
    : ensaio.resultados?.expansao || "";
}

function garantirCincoPontos(lista = []) {
  const base = [...lista];

  while (base.length < 5) {
    base.push({});
  }

  return base.slice(0, 5);
}

function garantirDuasUmidadesHigroscopicas(lista = []) {
  const base = [...lista];

  while (base.length < 2) {
    base.push({
      capsula: "",
      capsulaNumero: "",
      capsulaId: "",
      capsulaSoloAgua: "",
      capsulaSolo: "",
      agua: "",
      pesoCapsula: "",
      solo: "",
      umidade: "",
    });
  }

  return base.slice(0, 2);
}

function calcularUmidadePorCapsula(linha = {}) {
  const capsulaSoloAgua = numeroPesoMaterial(linha.capsulaSoloAgua);
const capsulaSolo = numeroPesoMaterial(linha.capsulaSolo);
const pesoCapsula = numeroPesoMaterial(linha.pesoCapsula);

  const agua =
    capsulaSoloAgua !== null && capsulaSolo !== null
      ? capsulaSoloAgua - capsulaSolo
      : null;

  const solo =
    capsulaSolo !== null && pesoCapsula !== null
      ? capsulaSolo - pesoCapsula
      : null;

  const umidade =
    agua !== null && solo !== null && solo !== 0 ? (agua / solo) * 100 : null;

  return {
    ...linha,
    agua: agua !== null ? formatarDecimal(arred(agua, 2), 2) : "",
solo: solo !== null ? formatarDecimal(arred(solo, 2), 2) : "",
umidade: umidade !== null ? formatarDecimal(arred(umidade, 2), 2) : "",
  };
}

function calcularPesoMaterialSeco(pesoMaterialUmido, umidadeMedia) {
  const pesoUmido = numeroPesoMaterial(pesoMaterialUmido);
  const umidade = numeroDecimal(umidadeMedia);

  if (pesoUmido === null || umidade === null) return "";

  // Excel: =ARRED(PESO_MATERIAL_UMIDO/(UMIDADE_MEDIA%+1);0)
  return formatarInteiroPt(arred(pesoUmido / (1 + umidade / 100), 0));
}

function propagarAguaAdicionadaPorPercentual(compactacao = [], contexto = {}) {
  const indiceReferencia = Number(contexto.indiceReferencia);
  const pesoMaterialUmido = numeroPesoMaterial(contexto.pesoMaterialUmido);
  const percentual = numeroDecimal(contexto.percentualAguaAdicionadaPadrao);
  const valorAguaReferencia = compactacao[indiceReferencia]?.aguaAdicionada;
  const aguaReferencia = numeroDecimal(valorAguaReferencia);
  const digitosAguaReferencia = String(valorAguaReferencia || "").replace(/\D/g, "").length;

  if (
    !Number.isInteger(indiceReferencia) ||
    indiceReferencia < 0 ||
    indiceReferencia >= compactacao.length ||
    digitosAguaReferencia < 3 ||
    pesoMaterialUmido === null ||
    percentual === null ||
    aguaReferencia === null
  ) {
    return compactacao;
  }

  const passoAgua = pesoMaterialUmido * (percentual / 100);

  return compactacao.map((linha, index) => {
    const aguaAdicionada = aguaReferencia + (index - indiceReferencia) * passoAgua;

    return {
      ...linha,
      aguaAdicionada: String(arred(aguaAdicionada, 0)),
    };
  });
}

function ajustarParabolaTresPontos(pontos = []) {
  if (pontos.length !== 3) return null;

  const [p1, p2, p3] = pontos;
  const x1 = p1.x;
  const y1 = p1.y;
  const x2 = p2.x;
  const y2 = p2.y;
  const x3 = p3.x;
  const y3 = p3.y;

  const denominador = (x1 - x2) * (x1 - x3) * (x2 - x3);
  if (denominador === 0) return null;

  const a =
    (x3 * (y2 - y1) + x2 * (y1 - y3) + x1 * (y3 - y2)) /
    denominador;
  const b =
    (x3 ** 2 * (y1 - y2) +
      x2 ** 2 * (y3 - y1) +
      x1 ** 2 * (y2 - y3)) /
    denominador;
  const c =
    (x2 * x3 * (x2 - x3) * y1 +
      x3 * x1 * (x3 - x1) * y2 +
      x1 * x2 * (x1 - x2) * y3) /
    denominador;

  return { a, b, c };
}

function resolverSistemaLinear(matriz, vetor) {
  const n = vetor.length;
  const a = matriz.map((linha, index) => [...linha, vetor[index]]);

  for (let coluna = 0; coluna < n; coluna += 1) {
    let pivo = coluna;
    for (let linha = coluna + 1; linha < n; linha += 1) {
      if (Math.abs(a[linha][coluna]) > Math.abs(a[pivo][coluna])) pivo = linha;
    }

    if (Math.abs(a[pivo][coluna]) < 1e-12) return null;

    [a[coluna], a[pivo]] = [a[pivo], a[coluna]];

    const divisor = a[coluna][coluna];
    for (let item = coluna; item <= n; item += 1) a[coluna][item] /= divisor;

    for (let linha = 0; linha < n; linha += 1) {
      if (linha === coluna) continue;
      const fator = a[linha][coluna];
      for (let item = coluna; item <= n; item += 1) {
        a[linha][item] -= fator * a[coluna][item];
      }
    }
  }

  return a.map((linha) => linha[n]);
}

function ajustarPolinomio(pontos = [], grauDesejado = 3) {
  const grau = Math.min(grauDesejado, pontos.length - 1);
  if (grau < 1) return null;

  const tamanho = grau + 1;
  const matriz = Array.from({ length: tamanho }, () => Array(tamanho).fill(0));
  const vetor = Array(tamanho).fill(0);

  pontos.forEach(({ x, y }) => {
    const potencias = Array.from({ length: tamanho * 2 - 1 }, (_, index) => x ** index);
    for (let linha = 0; linha < tamanho; linha += 1) {
      for (let coluna = 0; coluna < tamanho; coluna += 1) {
        matriz[linha][coluna] += potencias[linha + coluna];
      }
      vetor[linha] += y * potencias[linha];
    }
  });

  return resolverSistemaLinear(matriz, vetor);
}

function avaliarPolinomio(coeficientes, x) {
  if (!coeficientes) return null;
  return coeficientes.reduce((total, coeficiente, index) => total + coeficiente * x ** index, 0);
}

function encontrarMaximoPolinomio(coeficientes, minimo, maximo) {
  if (!coeficientes) return null;

  let melhor = { x: minimo, y: avaliarPolinomio(coeficientes, minimo) };
  const passos = 300;

  for (let index = 1; index <= passos; index += 1) {
    const x = minimo + ((maximo - minimo) / passos) * index;
    const y = avaliarPolinomio(coeficientes, x);
    if (Number.isFinite(y) && (!melhor || y > melhor.y)) melhor = { x, y };
  }

  return melhor;
}

function obterPontosCompactacaoValidos(ensaio = {}) {
  return (ensaio.compactacao || [])
    .map((ponto) => ({
      y: numeroDecimal(ponto.densidadeSeca),
      x: numeroDecimal(ponto.umidadeCalculada || ponto.umidade),
    }))
    .filter((ponto) => ponto.y !== null && ponto.x !== null)
    .sort((a, b) => a.x - b.x);
}

function gerarCurvaSplineNatural(pontos = [], amostrasPorTrecho = 16) {
  const dados = pontos
    .filter((ponto) => ponto.x !== null && ponto.y !== null)
    .sort((a, b) => a.x - b.x)
    .filter((ponto, index, lista) => index === 0 || ponto.x !== lista[index - 1].x);

  const n = dados.length;
  if (n < 3) {
    return dados.map((ponto) => ({
      umidade: ponto.x,
      densidadeSuavizada: ponto.y,
    }));
  }

  const segunda = Array(n).fill(0);
  const u = Array(n - 1).fill(0);

  for (let i = 1; i < n - 1; i += 1) {
    const sig = (dados[i].x - dados[i - 1].x) / (dados[i + 1].x - dados[i - 1].x);
    const p = sig * segunda[i - 1] + 2;
    segunda[i] = (sig - 1) / p;
    u[i] =
      (6 *
        ((dados[i + 1].y - dados[i].y) / (dados[i + 1].x - dados[i].x) -
          (dados[i].y - dados[i - 1].y) / (dados[i].x - dados[i - 1].x))) /
        (dados[i + 1].x - dados[i - 1].x) -
      sig * u[i - 1];
    u[i] /= p;
  }

  for (let k = n - 2; k >= 0; k -= 1) {
    segunda[k] = segunda[k] * segunda[k + 1] + u[k];
  }

  const curva = [];

  for (let i = 0; i < n - 1; i += 1) {
    const h = dados[i + 1].x - dados[i].x;
    if (h === 0) continue;

    for (let passo = 0; passo < amostrasPorTrecho; passo += 1) {
      const x = dados[i].x + (h * passo) / amostrasPorTrecho;
      const a = (dados[i + 1].x - x) / h;
      const b = (x - dados[i].x) / h;
      const y =
        a * dados[i].y +
        b * dados[i + 1].y +
        ((a ** 3 - a) * segunda[i] + (b ** 3 - b) * segunda[i + 1]) *
          (h ** 2) /
          6;

      curva.push({ umidade: Number(x.toFixed(4)), densidadeSuavizada: y });
    }
  }

  curva.push({
    umidade: dados[n - 1].x,
    densidadeSuavizada: dados[n - 1].y,
  });

  return curva;
}

function calcularResultadosCurvaCompactacao(ensaio = {}) {
  const pontos = obterPontosCompactacaoValidos(ensaio);

  if (pontos.length < 3) {
    return {
      densidadeMaxima: ensaio.resultados?.densidadeMaxima ?? "",
      umidadeOtima: ensaio.resultados?.umidadeOtima ?? "",
    };
  }

  const maiorPonto = pontos.reduce(
    (maior, ponto) => (ponto.y > maior.y ? ponto : maior),
    pontos[0]
  );

  const indiceMaior = pontos.findIndex(
    (ponto) => ponto.x === maiorPonto.x && ponto.y === maiorPonto.y
  );

  let pontosCurva;

  if (indiceMaior <= 0) {
    pontosCurva = pontos.slice(0, 3);
  } else if (indiceMaior >= pontos.length - 1) {
    pontosCurva = pontos.slice(-3);
  } else {
    pontosCurva = pontos.slice(indiceMaior - 1, indiceMaior + 2);
  }

  const ajuste = ajustarParabolaTresPontos(pontosCurva);

  if (!ajuste || ajuste.a >= 0) {
    return {
      densidadeMaxima: formatarDecimal(arred(maiorPonto.y, 3), 3),
      umidadeOtima: formatarDecimal(arred(maiorPonto.x, 1), 1),
    };
  }

  const umidadeCalculada = -ajuste.b / (2 * ajuste.a);
  const menorUmidade = Math.min(...pontos.map((ponto) => ponto.x));
  const maiorUmidade = Math.max(...pontos.map((ponto) => ponto.x));
  const umidadeBase =
    Number.isFinite(umidadeCalculada) &&
    umidadeCalculada >= menorUmidade &&
    umidadeCalculada <= maiorUmidade
      ? umidadeCalculada
      : maiorPonto.x;
  const umidadeOtima = umidadeBase;
  const densidadeCalculada =
    ajuste.a * umidadeOtima ** 2 + ajuste.b * umidadeOtima + ajuste.c;

  return {
    densidadeMaxima: formatarDecimal(arred(densidadeCalculada, 3), 3),
    umidadeOtima: formatarDecimal(arred(umidadeOtima, 1), 1),
  };
}
function calcularLinhaCompactacaoLocal(linha = {}, contexto = {}) {
  const linhaComUmidadeCapsula = calcularUmidadePorCapsula(linha);
  const pesoMaterialUmido = numeroPesoMaterial(contexto.pesoMaterialUmido);
  const pesoMaterialSeco = numeroPesoMaterial(contexto.pesoMaterialSeco);
  const umidadeMedia = numeroDecimal(contexto.umidadeMedia);
  const aguaAdicionada = numeroDecimal(linhaComUmidadeCapsula.aguaAdicionada);
  const pesoCilindro = numeroPesoMaterial(linhaComUmidadeCapsula.pesoCilindro);
  const volumeCilindro = numeroPesoMaterial(linhaComUmidadeCapsula.volumeCilindro);
  const textoMassaSoloAgua = String(
  linhaComUmidadeCapsula.pesoSoloUmidoMolde || ""
).replace(/\D/g, "");

const massaSoloAguaMolde =
  textoMassaSoloAgua.length >= 4
    ? numeroPesoMaterial(linhaComUmidadeCapsula.pesoSoloUmidoMolde)
    : null;

  const percentualAguaAdicionada =
    aguaAdicionada !== null && pesoMaterialUmido !== null && pesoMaterialUmido !== 0
      ? (aguaAdicionada / pesoMaterialUmido) * 100
      : null;

  const umidadeCalculadaPorAguaAdicionada =
    aguaAdicionada !== null &&
    pesoMaterialSeco !== null &&
    pesoMaterialSeco !== 0 &&
    umidadeMedia !== null
      ? (aguaAdicionada / pesoMaterialSeco) * 100 + umidadeMedia
      : null;
  const umidadeCalculada =
    numeroDecimal(linhaComUmidadeCapsula.umidade) ??
    umidadeCalculadaPorAguaAdicionada;

  const soloAgua =
    massaSoloAguaMolde !== null && pesoCilindro !== null
      ? massaSoloAguaMolde - pesoCilindro
      : null;

  const densidadeUmida =
  soloAgua !== null && volumeCilindro !== null && volumeCilindro !== 0
    ? (soloAgua / volumeCilindro) * 1000
    : null;

  const densidadeConvertida =
    densidadeUmida !== null &&
    percentualAguaAdicionada !== null
      ? (densidadeUmida / (percentualAguaAdicionada + 100)) * 100
      : null;

  const densidadeSeca =
  densidadeUmida !== null &&
  umidadeCalculada !== null
    ? densidadeUmida / (1 + umidadeCalculada / 100)
    : null;

  return {
    ...linhaComUmidadeCapsula,
    percentualAguaAdicionada:
      percentualAguaAdicionada !== null
        ? formatarDecimal(arred(percentualAguaAdicionada, 1), 1)
        : "",
    umidadeCalculada:
      umidadeCalculada !== null
        ? formatarDecimal(arred(umidadeCalculada, 1), 1)
        : "",
    soloAgua: soloAgua !== null ? formatarInteiroPt(arred(soloAgua, 0)) : "",
densidadeUmida:
  densidadeUmida !== null ? formatarInteiroPt(arred(densidadeUmida, 0)) : "",
densidadeConvertida:
  densidadeConvertida !== null
    ? formatarInteiroPt(arred(densidadeConvertida, 0))
    : "",
densidadeSeca:
  densidadeSeca !== null ? formatarInteiroPt(arred(densidadeSeca, 0)) : "",
  };
}

function calcularLinhaExpansaoLocal(linha = {}, compactacaoLinha = {}) {
  const leituraInicial = numeroDecimal(linha.leituraInicial);
  const leituraFinal = numeroDecimal(linha.leituraFinal);

  const alturaCilindro = numeroDecimal(
    compactacaoLinha.alturaCilindro ||
      compactacaoLinha.altura ||
      compactacaoLinha.alturaCp ||
      compactacaoLinha.alturaCP
  );

  const diferenca =
    leituraInicial !== null && leituraFinal !== null
      ? leituraFinal - leituraInicial
      : null;

  const expansao =
    diferenca !== null && alturaCilindro !== null && alturaCilindro !== 0
      ? (diferenca / alturaCilindro) * 100
      : null;

  return {
    ...linha,
    alturaCilindro:
      alturaCilindro !== null ? formatarDecimal(arred(alturaCilindro, 2), 2) : "",
    diferenca:
      diferenca !== null ? formatarDecimal(arred(diferenca, 3), 3) : "",
    expansao:
      expansao !== null ? formatarDecimal(arred(expansao, 2), 2) : "",
  };
}

function limitarFaixa(valor, maximo) {
  if (valor === null || valor === undefined || !Number.isFinite(valor)) return null;
  if (valor < 0) return 0;
  if (valor > maximo) return maximo;
  return valor;
}

function obterPassantePeneira(peneiramento = [], peneiraAlvo) {
  const item = (peneiramento || []).find((linha) => {
    const peneira = String(linha.peneira || linha.nome || linha.numero || "").trim();
    return peneira === String(peneiraAlvo);
  });

  return numeroDecimal(item?.percentualPassante);
}

function calcularClassificacaoSucs(granulometria = {}, limites = {}) {
  const peneiramento = granulometria.peneiramento || [];

  const p4 = obterPassantePeneira(peneiramento, "4");
  const p200 = obterPassantePeneira(peneiramento, "200");

  const resultadosLimites = calcularResultadosLimites(limites || {});
  const ll = numeroDecimal(resultadosLimites.limiteLiquidez);
  const ip = numeroDecimal(resultadosLimites.indicePlasticidade);

  if (p200 === null) return "";

  const linhaA = ll !== null ? 0.73 * (ll - 20) : null;

  if (p200 < 50) {
    const grosso = p4 !== null && p4 > 50 ? "S" : "G";

    if (p200 < 5) {
      return grosso === "G" ? "GP" : "SP";
    }

    if (p200 >= 5 && p200 <= 12) {
      if (ll === null || ip === null || linhaA === null) return grosso;
      if (ip >= linhaA && ip > 7) return grosso === "G" ? "GC" : "SC";
      if (ip < 4 || ip < linhaA) return grosso === "G" ? "GM" : "SM";
      return grosso === "G" ? "GM-GC" : "SM-SC";
    }

    if (ll === null || ip === null || linhaA === null) return grosso;
    if (ip >= linhaA && ip > 7) return grosso === "G" ? "GC" : "SC";
    if (ip < 4 || ip < linhaA) return grosso === "G" ? "GM" : "SM";
    return grosso === "G" ? "GM-GC" : "SM-SC";
  }

  if (ll === null || ip === null || linhaA === null) return "";

  if (ll < 50) {
    if (ip >= linhaA && ip > 7) return "CL";
    if (ip < 4 || ip < linhaA) return "ML";
    return "ML-CL";
  }

  if (ip >= linhaA) return "CH";
  return "MH";
}

function calcularClassificacaoTrb(granulometria = {}, limites = {}) {
  const peneiramento = granulometria.peneiramento || [];

  const p10 = obterPassantePeneira(peneiramento, "10");
  const p40 = obterPassantePeneira(peneiramento, "40");
  const p200 = obterPassantePeneira(peneiramento, "200");

  const resultadosLimites = calcularResultadosLimites(limites || {});
  const ll = numeroDecimal(resultadosLimites.limiteLiquidez);
  const ip = numeroDecimal(resultadosLimites.indicePlasticidade);

  if (p200 === null) return "";

  if (
    p10 !== null && p10 <= 50 &&
    p40 !== null && p40 <= 30 &&
    p200 <= 15 &&
    (ip === null || ip <= 6)
  ) {
    return "A-1-a";
  }

  if (
    p40 !== null && p40 <= 50 &&
    p200 <= 25 &&
    (ip === null || ip <= 6)
  ) {
    return "A-1-b";
  }

  if (
    p40 !== null && p40 >= 51 &&
    p200 <= 10 &&
    (ip === null || ip === 0)
  ) {
    return "A-3";
  }

  if (p200 <= 35) {
    if (ll !== null && ip !== null) {
      if (ll <= 40 && ip <= 10) return "A-2-4";
      if (ll >= 41 && ip <= 10) return "A-2-5";
      if (ll <= 40 && ip >= 11) return "A-2-6";
      if (ll >= 41 && ip >= 11) return "A-2-7";
    }

    return "A-2";
  }

  if (ll === null || ip === null) return "";

  if (ll <= 40 && ip <= 10) return "A-4";
  if (ll >= 41 && ip <= 10) return "A-5";
  if (ll <= 40 && ip >= 11) return "A-6";

  if (ll >= 41 && ip >= 11) {
    return ip <= ll - 30 ? "A-7-5" : "A-7-6";
  }

  return "";
}

function calcularIndiceGrupo(granulometria = {}, limites = {}) {
  const peneira200 = (granulometria.peneiramento || []).find((item) => {
    const peneira = String(item.peneira || item.nome || item.numero || "").trim();
    return peneira === "200";
  });

  const percentualPassante200 = numeroDecimal(peneira200?.percentualPassante);
  const f = percentualPassante200 !== null ? Math.round(percentualPassante200) : null;

  const resultadosLimites = calcularResultadosLimites(limites || {});
  const ll = numeroDecimal(resultadosLimites?.limiteLiquidez);
  const ip = numeroDecimal(resultadosLimites?.indicePlasticidade);

  if (f === null || ll === null || ip === null) return "";

  const a = limitarFaixa(f - 35, 40);
  const b = limitarFaixa(f - 15, 40);
  const c = limitarFaixa(ll - 40, 20);
  const d = limitarFaixa(ip - 10, 20);

  const ig = 0.2 * a + 0.005 * a * c + 0.01 * b * d;

  return formatarInteiroPt(arred(ig, 0));
}

function recalcularCompactacaoCompleta(ensaio, opcoes = {}) {
  const granulometria = {
    ...estadoInicialCompactacao.granulometria,
    ...(ensaio.granulometria || {}),
  };

  const peneiramentoOriginal = granulometria.peneiramento || [];
  const peneiramento = peneiramentoOriginal;

const peneirasAte10 = [
  '4"',
  '3"',
  '2"',
  '1 1/2"',
  '1"',
  '3/4"',
  '1/2"',
  '3/8"',
  '4',
  '8',
  '10',
];

const soloSecoRetidoPeneira10 = peneiramento.reduce((total, item) => {
  const peneira = String(
    item.peneira ||
    item.descricao ||
    item.nome ||
    item.numero ||
    ""
  ).trim();

  if (peneirasAte10.includes(peneira)) {
    return total + (numeroDecimal(item.pesoRetido) || 0);
  }

  return total;
}, 0);

  const umidadesHigroscopicas = garantirDuasUmidadesHigroscopicas(
    granulometria.umidadeHigroscopica || []
  ).map(calcularUmidadePorCapsula);

  const umidadesValidas = umidadesHigroscopicas
    .map((linha) => numeroDecimal(linha.umidade))
    .filter((valor) => valor !== null);

  const umidadeMedia =
    umidadesValidas.length > 0
      ? umidadesValidas.reduce((total, valor) => total + valor, 0) /
        umidadesValidas.length
      : null;

  const umidadeMediaFormatada =
    umidadeMedia !== null ? formatarDecimal(arred(umidadeMedia, 1), 1) : "";
    const amostraTotalUmida = numeroDecimal(
  granulometria.amostraSeca?.amostraTotalUmida
);
const umidadeMediaNumero = numeroDecimal(umidadeMediaFormatada);

const soloUmidoPassante10 =
  amostraTotalUmida !== null
    ? amostraTotalUmida - soloSecoRetidoPeneira10
    : null;

const soloSecoPassante10 =
  soloUmidoPassante10 !== null && umidadeMediaNumero !== null
    ? soloUmidoPassante10 / (1 + umidadeMediaNumero / 100)
    : null;

const amostraTotalSeca =
  amostraTotalUmida !== null &&
  soloSecoRetidoPeneira10 !== null &&
  umidadeMediaNumero !== null
    ? (
        ((amostraTotalUmida - soloSecoRetidoPeneira10) /
          (100 + umidadeMediaNumero)) *
        100
      ) + soloSecoRetidoPeneira10
    : null;

const amostraMenor10Umida = numeroDecimal(
  granulometria.amostraSeca?.amostraMenor10Umida
);

const amostraMenor10Seca =
  amostraMenor10Umida !== null && umidadeMediaNumero !== null
    ? amostraMenor10Umida / (1 + umidadeMediaNumero / 100)
    : null;

 let acumuladoPercentual = 0;
let percentualPassante10 = null;

const peneiramentoCalculado = peneiramento.map((item) => {
  const pesoRetido = numeroDecimal(item.pesoRetido);

  const peneiraNumero = numeroDecimal(
    item.mm || item.abertura || item.peneiraMm
  );

  let percentualRetido = null;

  if (
    pesoRetido !== null &&
    amostraTotalSeca !== null &&
    amostraTotalSeca !== 0 &&
    (peneiraNumero === null || peneiraNumero >= 2)
  ) {
    percentualRetido = (pesoRetido / amostraTotalSeca) * 100;
  } else if (
    pesoRetido !== null &&
    amostraMenor10Seca !== null &&
    amostraMenor10Seca !== 0 &&
    percentualPassante10 !== null &&
    peneiraNumero !== null &&
    peneiraNumero < 2
  ) {
    percentualRetido = (pesoRetido / amostraMenor10Seca) * percentualPassante10;
  }

  if (percentualRetido !== null) {
    acumuladoPercentual += percentualRetido;
  }

  const percentualPassante =
    percentualRetido !== null ? 100 - acumuladoPercentual : null;

  if (peneiraNumero === 2 && percentualPassante !== null) {
    percentualPassante10 = percentualPassante;
  }

  return {
    ...item,
    percentualRetido:
      percentualRetido !== null
        ? formatarDecimal(arred(percentualRetido, 1), 1)
        : "",

    acumulado:
      percentualRetido !== null
        ? formatarDecimal(arred(acumuladoPercentual, 1), 1)
        : "",

    percentualPassante:
      percentualPassante !== null
        ? formatarDecimal(arred(percentualPassante, 1), 1)
        : "",
  };
});

const resultadosLimites = calcularResultadosLimites(ensaio.limites || {});

const classificacaoIg = calcularIndiceGrupo(
  {
    ...granulometria,
    peneiramento: peneiramentoCalculado,
  },
  {
    ...(ensaio.limites || {}),
    resultados: resultadosLimites,
  }
);

const classificacaoTrb = calcularClassificacaoTrb(
  {
    ...granulometria,
    peneiramento: peneiramentoCalculado,
  },
  {
    ...(ensaio.limites || {}),
    resultados: resultadosLimites,
  }
);

const classificacaoSucs = calcularClassificacaoSucs(
  {
    ...granulometria,
    peneiramento: peneiramentoCalculado,
  },
  {
    ...(ensaio.limites || {}),
    resultados: resultadosLimites,
  }
);

  const pesoMaterialSeco = calcularPesoMaterialSeco(
    ensaio.pesoMaterialUmido,
    umidadeMediaFormatada
  );

  const compactacaoBase = propagarAguaAdicionadaPorPercentual(
    garantirCincoPontos(ensaio.compactacao || criarPontosCompactacao()),
    {
      indiceReferencia: ensaio.aguaAdicionadaReferencia?.index,
      pesoMaterialUmido: ensaio.pesoMaterialUmido,
      percentualAguaAdicionadaPadrao: ensaio.percentualAguaAdicionadaPadrao,
    }
  );

  const compactacao = compactacaoBase.map(
    (linha) =>
      calcularLinhaCompactacaoLocal(linha, {
        pesoMaterialUmido: ensaio.pesoMaterialUmido,
        pesoMaterialSeco,
        umidadeMedia: umidadeMediaFormatada,
      })
  );

  const expansao = sincronizarDatasExpansao(
    garantirCincoPontos(ensaio.expansao || criarExpansao()),
    ensaio.dataEnsaio
  ).map((linha, index) =>
    calcularLinhaExpansaoLocal(linha, compactacao[index] || {})
  );

  const cbr = garantirCincoPontos(ensaio.cbr || criarCBR()).map((linha, index) =>
    calcularLinhaCbrLocal(
      {
        ...linha,
        cilindro: linha.cilindro || compactacao[index]?.cilindroNumero || compactacao[index]?.cilindro || "",
      },
      ensaio
    )
  );
  const campoIsc = selecionarCampoIsc(cbr);
  const cbrComIscSelecionado = cbr.map((linha) => ({
    ...linha,
    isc: linha[campoIsc] || "",
  }));

  const proximo = {
    ...ensaio,
    umidadeMedia: umidadeMediaFormatada,
    pesoMaterialSeco,
    compactacao,
expansao,
cbr: cbrComIscSelecionado,
limites: {
  ...(ensaio.limites || {}),
  resultados: resultadosLimites,
},
granulometria: {
  ...granulometria, 
  peneiramento: peneiramentoCalculado,
classificacaoIg,
classificacaoTrb,
classificacaoSucs,
  umidadeHigroscopica: umidadesHigroscopicas,
  umidadeMedia: umidadeMediaFormatada,
  umidadeHigroscopica: umidadesHigroscopicas,
  umidadeMedia: umidadeMediaFormatada,

  soloSecoRetidoPeneira10:
    soloSecoRetidoPeneira10 > 0
      ? formatarDecimal(arred(soloSecoRetidoPeneira10, 1), 1)
      : "",

  soloUmidoPassante10:
    soloUmidoPassante10 !== null
      ? formatarDecimal(arred(soloUmidoPassante10, 1), 1)
      : "",

  soloSecoPassante10:
    soloSecoPassante10 !== null
      ? formatarDecimal(arred(soloSecoPassante10, 1), 1)
      : "",

  amostraTotalSeca:
    amostraTotalSeca !== null
      ? formatarDecimal(arred(amostraTotalSeca, 1), 1)
      : "",

  amostraMenor10Umida:
    amostraMenor10Umida !== null
      ? formatarDecimal(arred(amostraMenor10Umida, 1), 1)
      : "",

  amostraMenor10Seca:
    amostraMenor10Seca !== null
      ? formatarDecimal(arred(amostraMenor10Seca, 1), 1)
      : "",
},
  };

  const resultadosModelo = recalcularResultados(proximo);
  const resultadosCurva = calcularResultadosCurvaCompactacao(proximo);
  const resultadosBase = {
    ...proximo.resultados,
    ...resultadosModelo,
    ...resultadosCurva,
  };
  const resultadosManuais = proximo.resultadosManuais || {};
  const resultadosAjustados = {
    ...resultadosBase,
    densidadeMaxima: !opcoes.forcarResultadosCurva && resultadosManuais.densidadeMaxima
      ? proximo.resultados?.densidadeMaxima || ""
      : resultadosBase.densidadeMaxima,
    umidadeOtima: !opcoes.forcarResultadosCurva && resultadosManuais.umidadeOtima
      ? proximo.resultados?.umidadeOtima || ""
      : resultadosBase.umidadeOtima,
  };

  return {
    ...proximo,
    resultados: {
      ...resultadosAjustados,
      isc: calcularIscFinal({
        ...proximo,
        resultados: resultadosAjustados,
      }),
      expansao: calcularExpansaoFinal({
        ...proximo,
        resultados: resultadosAjustados,
      }),
    },
  };
}

function liberarResultadosCurvaCompactacao(ensaio = {}) {
  const resultadosManuais = { ...(ensaio.resultadosManuais || {}) };
  delete resultadosManuais.densidadeMaxima;
  delete resultadosManuais.umidadeOtima;

  return {
    ...ensaio,
    resultadosManuais,
  };
}

function recalcularCompactacaoComResultadosCurva(ensaio = {}) {
  return recalcularCompactacaoCompleta(
    liberarResultadosCurvaCompactacao(ensaio),
    { forcarResultadosCurva: true }
  );
}

function recalcularLinhasCompactacaoPorUmidadeMedia(ensaio = {}) {
  const umidadeMedia = numeroDecimal(ensaio.umidadeMedia);
  if (umidadeMedia === null) return ensaio;

  const pesoMaterialSeco = calcularPesoMaterialSeco(
    ensaio.pesoMaterialUmido,
    ensaio.umidadeMedia
  );
  const compactacao = propagarAguaAdicionadaPorPercentual(
    garantirCincoPontos(ensaio.compactacao || criarPontosCompactacao()),
    {
      indiceReferencia: ensaio.aguaAdicionadaReferencia?.index,
      pesoMaterialUmido: ensaio.pesoMaterialUmido,
      percentualAguaAdicionadaPadrao: ensaio.percentualAguaAdicionadaPadrao,
    }
  ).map((linha) =>
    calcularLinhaCompactacaoLocal(linha, {
      pesoMaterialUmido: ensaio.pesoMaterialUmido,
      pesoMaterialSeco,
      umidadeMedia: ensaio.umidadeMedia,
    })
  );

  return {
    ...ensaio,
    pesoMaterialSeco,
    compactacao,
  };
}

function garantirCincoLimites(lista = []) {
  const base = [...lista];

  while (base.length < 5) {
    base.push({
      capsulaNumero: "",
      capsula: "",
      capsulaId: "",
      capsulaSoloAgua: "",
      capsulaSolo: "",
      agua: "",
      pesoCapsula: "",
      solo: "",
      umidade: "",
      numeroGolpes: "",
    });
  }

  return base.slice(0, 5);
}

function calcularLinhaLimiteFisico(linha = {}) {
  const capsulaSoloAgua = numeroDecimal(linha.capsulaSoloAgua);
  const capsulaSolo = numeroDecimal(linha.capsulaSolo);
  const pesoCapsula = numeroDecimal(linha.pesoCapsula || linha.pesoTampa);

  const agua =
    capsulaSoloAgua !== null && capsulaSolo !== null
      ? capsulaSoloAgua - capsulaSolo
      : numeroDecimal(linha.agua);

  const solo =
    capsulaSolo !== null && pesoCapsula !== null
      ? capsulaSolo - pesoCapsula
      : numeroDecimal(linha.solo);

  const umidade =
    agua !== null && solo !== null && solo !== 0
      ? (agua / solo) * 100
      : numeroDecimal(linha.umidade);

  return {
    ...linha,
    agua: agua !== null ? formatarDecimal(arred(agua, 2), 2) : linha.agua || "",
    solo: solo !== null ? formatarDecimal(arred(solo, 2), 2) : linha.solo || "",
    umidade:
      umidade !== null ? formatarDecimal(arred(umidade, 1), 1) : linha.umidade || "",
  };
}

function pesoCapsulaLimite(capsula, tipoCapsula) {
  if (!capsula) return "";

  if (tipoCapsula === "limite_plasticidade") {
    return (
      capsula.pesoTampa ||
      capsula.pesoCapsula ||
      capsula.peso ||
      capsula.massa ||
      ""
    );
  }

  return (
    capsula.pesoCapsula ||
    capsula.peso ||
    capsula.massa ||
    capsula.pesoTampa ||
    ""
  );
}

function buscarCapsulaLimitePorNumero(lista, valor, tipoCapsula) {
  const numeroDigitado = normalizarNumero(valor);
  if (!numeroDigitado) return null;
  const listaCompleta = [
    ...(lista || []),
    ...capsulasLimiteLiquidezPadrao,
    ...tampasLimitePlasticidadePadrao,
  ];

  const porNumero = listaCompleta.filter((capsula) => {
    const numeroBanco = normalizarNumero(
      capsula.numero ||
        capsula.numeroCapsula ||
        capsula.numeroTampa ||
        capsula.codigo ||
        capsula.id
    );
    return numeroBanco === numeroDigitado;
  });

  const porTipo = porNumero.find((capsula) => capsula.tipo === tipoCapsula);
  if (porTipo) return porTipo;

  const aliases =
    tipoCapsula === "limite_plasticidade"
      ? ["lp", "tampa", "tampas", "limite_plasticidade"]
      : ["ll", "liquidez", "limite_liquidez"];

  const porAlias = porNumero.find((capsula) => {
    const tipo = String(capsula.tipo || capsula.categoria || capsula.grupo || "").toLowerCase();
    return aliases.some((alias) => tipo.includes(alias));
  });
  if (porAlias) return porAlias;

  return (
    porNumero.find((capsula) =>
      tipoCapsula === "limite_plasticidade"
        ? capsula.pesoTampa || capsula.pesoCapsula
        : capsula.pesoCapsula || capsula.peso
    ) || null
  );
}

function completarLinhaLimiteComCapsula(linha = {}, capsulas = [], tipoCapsula) {
  const numeroCapsula = linha.capsulaNumero || linha.capsula;
  const campoPeso =
    tipoCapsula === "limite_plasticidade" ? "pesoTampa" : "pesoCapsula";

  if (!numeroCapsula || linha[campoPeso]) return linha;

  const capsula = buscarCapsulaLimitePorNumero(capsulas, numeroCapsula, tipoCapsula);
  const peso = pesoCapsulaLimite(capsula, tipoCapsula);
  if (!peso) return linha;

  return {
    ...linha,
    capsula: numeroCapsula,
    capsulaNumero: numeroCapsula,
    capsulaId: capsula?.id || linha.capsulaId || "",
    pesoCapsula: tipoCapsula === "limite_plasticidade" ? "" : peso,
    pesoTampa: tipoCapsula === "limite_plasticidade" ? peso : "",
  };
}

function normalizarLinhasPlasticidadePorPeso(
  linhas = [],
  capsulas = [],
  tipoPesoPlasticidade = "tampa"
) {
  const usarCapsula = tipoPesoPlasticidade === "capsula";
  const tipoCadastro = usarCapsula
    ? "limite_liquidez"
    : "limite_plasticidade";

  return garantirCincoLimites(linhas).map((linha) => {
    const numeroCapsula = linha.capsulaNumero || linha.capsula;
    const capsula = buscarCapsulaLimitePorNumero(
      capsulas,
      numeroCapsula,
      tipoCadastro
    );
    const pesoCadastro = pesoCapsulaLimite(capsula, tipoCadastro);
    const peso =
      pesoCadastro ||
      (usarCapsula ? linha.pesoCapsula : linha.pesoTampa) ||
      "";

    return calcularLinhaLimiteFisico({
      ...linha,
      capsula: numeroCapsula,
      capsulaNumero: numeroCapsula,
      capsulaId: capsula?.id || linha.capsulaId || "",
      pesoCapsula: usarCapsula ? peso : "",
      pesoTampa: usarCapsula ? "" : peso,
    });
  });
}

function calcularLLPorInterpolacaoLog(liquidez = []) {
  const pontos = liquidez
    .map((linha) => ({
      golpes: numeroDecimal(linha.numeroGolpes || linha.golpes),
      umidade: numeroDecimal(linha.umidade),
    }))
    .filter((ponto) => ponto.golpes !== null && ponto.golpes > 0 && ponto.umidade !== null);

  if (pontos.length < 2) return "";

  const n = pontos.length;
  const somaX = pontos.reduce((total, ponto) => total + Math.log10(ponto.golpes), 0);
  const somaY = pontos.reduce((total, ponto) => total + ponto.umidade, 0);
  const somaXY = pontos.reduce(
    (total, ponto) => total + Math.log10(ponto.golpes) * ponto.umidade,
    0
  );
  const somaX2 = pontos.reduce(
    (total, ponto) => total + Math.log10(ponto.golpes) ** 2,
    0
  );

  const denominador = n * somaX2 - somaX ** 2;
  if (denominador === 0) return "";

  const a = (n * somaXY - somaX * somaY) / denominador;
  const b = (somaY - a * somaX) / n;

  const limiteLiquidez = a * Math.log10(25) + b;

  return Number.isFinite(limiteLiquidez)
    ? formatarDecimal(arred(limiteLiquidez, 1), 1)
    : "";
}


function obterPlasticidadeAceita(plasticidade = []) {
  const valores = plasticidade
    .map(calcularLinhaLimiteFisico)
    .map((linha, index) => ({
      index,
      umidade: numeroDecimal(linha.umidade),
    }))
    .filter((item) => item.umidade !== null);

  if (valores.length < 3) {
    return { media: "", indicesAceitos: [] };
  }

  function combinacoes(lista, tamanho) {
    const resultado = [];

    function montar(inicio, atual) {
      if (atual.length === tamanho) {
        resultado.push(atual);
        return;
      }

      for (let i = inicio; i < lista.length; i += 1) {
        montar(i + 1, [...atual, lista[i]]);
      }
    }

    montar(0, []);
    return resultado;
  }

  for (let tamanho = valores.length; tamanho >= 3; tamanho -= 1) {
    const grupos = combinacoes(valores, tamanho);

    for (const grupo of grupos) {
      const media =
        grupo.reduce((soma, item) => soma + item.umidade, 0) / grupo.length;

      const aceito = grupo.every(
        (item) => Math.abs(item.umidade - media) <= media * 0.05
      );

      if (aceito) {
        return {
          media: formatarDecimal(arred(media, 1), 1),
          indicesAceitos: grupo.map((item) => item.index),
        };
      }
    }
  }

  return { media: "", indicesAceitos: [] };
}

function calcularMediaUmidadePlasticidade(plasticidade = []) {
  return obterPlasticidadeAceita(plasticidade).media;
}

function calcularResultadosLimites(limites = {}) {
  const liquidez = garantirCincoLimites(limites.liquidez || []).map(
    calcularLinhaLimiteFisico
  );

  const plasticidade = garantirCincoLimites(limites.plasticidade || []).map(
    calcularLinhaLimiteFisico
  );

  const limiteLiquidez = calcularLLPorInterpolacaoLog(liquidez);
  const limitePlasticidade = calcularMediaUmidadePlasticidade(plasticidade);

  const ll = numeroDecimal(limiteLiquidez);
  const lp = numeroDecimal(limitePlasticidade);

  const indicePlasticidade =
    ll !== null && lp !== null ? formatarDecimal(arred(ll - lp, 1), 1) : "";

  return {
    ...(limites.resultados || {}),
    limiteLiquidez,
    limitePlasticidade,
    indicePlasticidade,
  };
}

export default function DetalhesCompactacao() {
  const { compactacaoId } = useParams();
  const history = useHistory();

  const [ensaio, setEnsaio] = useState(null);
  const [ensaioOriginal, setEnsaioOriginal] = useState(null);
  const [cilindros, setCilindros] = useState([]);
  const [capsulas, setCapsulas] = useState([]);
  const [faixasDnit, setFaixasDnit] = useState([]);
  const [tab, setTab] = useState(0);
  const metadadosCabecalho = [
    { rq: "RQ 2.1.1-A", revisao: "01" },
    { rq: "RQ 2.1.1-B", revisao: "01" },
    { rq: "RQ 2.1.1-C", revisao: "01" },
    { rq: "RQ 2.1.1-D", revisao: "00" },
    { rq: "RQ 2.1.1-D", revisao: "00" },
  ][tab];
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [modoPrint, setModoPrint] = useState(false);
  const [editando, setEditando] = useState(true);
  const [avisoAprovacao, setAvisoAprovacao] = useState("");
  const [erro, setErro] = useState("");
  const [confirmacaoUmidadePonto, setConfirmacaoUmidadePonto] = useState(null);
  const aguaAdicionadaTimerRef = React.useRef(null);
  const umidadePontoTimerRef = React.useRef(null);
  function iniciarEdicao() {
  if (!editando) {
    setEditando(true);
  }
}

  useEffect(() => {
    carregar();
  }, [compactacaoId]);

  useEffect(() => {
    return () => {
      if (aguaAdicionadaTimerRef.current) {
        clearTimeout(aguaAdicionadaTimerRef.current);
      }
      if (umidadePontoTimerRef.current) {
        clearTimeout(umidadePontoTimerRef.current);
      }
    };
  }, []);

  async function carregar() {
    setLoading(true);

    const [ensaioSnap, cilindrosSnap, capsulasSnap, faixasSnap] = await Promise.all([
      getDoc(doc(db, COLLECTION_COMPACTACAO, compactacaoId)),
      getDocs(
        consultaTenantAtual(query(collection(db, COLLECTION_CILINDROS), orderBy("numero", "asc")))
      ),
      getDocs(
        consultaTenantAtual(query(collection(db, COLLECTION_CAPSULAS), orderBy("numero", "asc")))
      ),
      getDocs(
        consultaTenantAtual(query(collection(db, COLLECTION_FAIXAS_DNIT), orderBy("ordem", "asc")))
      ),
    ]);

    const cilindrosCarregados = cilindrosSnap.docs.map((item) => ({
      id: item.id,
      ...item.data(),
    }));

    const capsulasCarregadas = capsulasSnap.docs.map((item) => ({
      id: item.id,
      ...item.data(),
    }));
    const faixasCarregadas = faixasSnap.docs.map((item) => ({
      id: item.id,
      ...item.data(),
    }));

    setCilindros(cilindrosCarregados);
    setCapsulas(capsulasCarregadas);
    setFaixasDnit(faixasCarregadas.length ? faixasCarregadas : faixasDnitPadrao);

    if (ensaioSnap.exists()) {
      const dados = ensaioSnap.data();

      const ensaioCarregado = {
        ...estadoInicialCompactacao,
        ...dados,
        registroNumero: dados.registroNumero || dados.codigo || "",
        espessuraDisco: dados.espessuraDisco || estadoInicialCompactacao.espessuraDisco,
        camadas: dados.camadas || estadoInicialCompactacao.camadas,
        compactacao: dados.compactacao?.length
          ? garantirCincoPontos(dados.compactacao).map((linha) => {
              const cilindro = buscarCilindroPorNumero(
                cilindrosCarregados,
                linha.cilindroNumero || linha.cilindro || linha.numeroCilindro || ""
              );

              return {
                ...linha,
                pesoCilindro: linha.pesoCilindro || obterPesoCilindro(cilindro),
volumeCilindro: linha.volumeCilindro || obterVolumeCilindro(cilindro),
alturaCilindro: linha.alturaCilindro || obterAlturaCilindro(cilindro),
              };
            })
          : garantirCincoPontos(criarPontosCompactacao()),
        expansao: dados.expansao?.length ? dados.expansao : criarExpansao(),
        cbr: dados.cbr?.length ? dados.cbr : criarCBR(),
        granulometria: {
          ...estadoInicialCompactacao.granulometria,
          ...(dados.granulometria || {}),
          umidadeHigroscopica: garantirDuasUmidadesHigroscopicas(
            dados.granulometria?.umidadeHigroscopica || []
          ),
          peneiramento: dados.granulometria?.peneiramento?.length
            ? dados.granulometria.peneiramento
            : criarGranulometria(),
        },
        limites: {
          ...criarLimites(),
          ...(dados.limites || {}),
        },
        substituicaoSolo: {
          ...criarSubstituicaoSolo(),
          ...(dados.substituicaoSolo || {}),
        },
      };

      const recalculado = recalcularCompactacaoCompleta(ensaioCarregado);
      setEnsaio(recalculado);
      setEnsaioOriginal(recalculado);
    }

    setEditando(false);
    setLoading(false);
  }

function atualizar(parcial, opcoes = {}) {
  iniciarEdicao();
  
  const proximo = { ...ensaio, ...parcial };
  setEnsaio(
    opcoes.liberarResultadosCurva
      ? recalcularCompactacaoComResultadosCurva(proximo)
      : recalcularCompactacaoCompleta(proximo)
  );
}

  function atualizarLista(campo, index, parcial) {
    iniciarEdicao();
    const lista = [...(ensaio[campo] || [])];
    lista[index] = { ...lista[index], ...parcial };
    atualizar({ [campo]: lista });
  }

  function atualizarSubstituicaoSolo(campo, valor) {
    atualizar({
      substituicaoSolo: {
        ...criarSubstituicaoSolo(),
        ...(ensaio.substituicaoSolo || {}),
        [campo]: valor,
      },
    });
  }

  function atualizarLeituraDiariaExpansao(index, leituraIndex, parcial) {
    const linha = ensaio.expansao?.[index] || {};
    const leiturasDiarias = [...(linha.leiturasDiarias || [])];
    leiturasDiarias[leituraIndex] = {
      ...(leiturasDiarias[leituraIndex] || {}),
      ...parcial,
    };
    atualizarLista("expansao", index, { leiturasDiarias });
  }

  function alternarCorrecaoCbr(index, linha, ativo) {
    if (!ativo) {
      atualizarLista("cbr", index, { aplicarCorrecao: false });
      return;
    }

    const deslocamentoInformado = numeroDecimal(linha.correcaoCbrMm);
    const deslocamentoEstimado =
      deslocamentoInformado !== null && deslocamentoInformado > 0
        ? deslocamentoInformado
        : estimarDeslocamentoCorrecaoCbr(linha.leituras || []);

    if (deslocamentoEstimado === null) {
      setErro(
        `Não foi identificado deslocamento positivo para o CP ${
          linha.cilindro || index + 1
        }. A curva não indica correção pela tangente de maior inclinação.`
      );
      atualizarLista("cbr", index, {
        aplicarCorrecao: false,
        correcaoCbrMm: "",
      });
      return;
    }

    setErro("");
    atualizarLista("cbr", index, {
      aplicarCorrecao: true,
      correcaoCbrMm: formatarDecimal(arred(deslocamentoEstimado, 2), 2),
    });
  }

  function atualizarGranulometria(campo, valor) {
    iniciarEdicao();
    atualizar({
      granulometria: {
        ...ensaio.granulometria,
        [campo]: valor,
      },
    });
  }

function atualizarLimites(secao, valor) {
  iniciarEdicao();
  const limitesAtualizados = {
    ...ensaio.limites,
    [secao]: valor,
  };

  atualizar({
    limites: {
      ...limitesAtualizados,
      resultados: calcularResultadosLimites(limitesAtualizados),
    },
  });
}

function atualizarTipoPesoPlasticidade(tipoPesoPlasticidade) {
  iniciarEdicao();
  const plasticidade = normalizarLinhasPlasticidadePorPeso(
    ensaio.limites.plasticidade || [],
    capsulas,
    tipoPesoPlasticidade
  );
  const limitesAtualizados = {
    ...ensaio.limites,
    tipoPesoPlasticidade,
    plasticidade,
  };

  atualizar({
    limites: {
      ...limitesAtualizados,
      resultados: calcularResultadosLimites(limitesAtualizados),
    },
  });
}

function atualizarGrupoLimites(grupo, campo, valor) {
  iniciarEdicao();
  const grupoAtual = ensaio.limites?.[grupo] || {};

  atualizarLimites(grupo, {
    ...grupoAtual,
    [campo]: valor,
  });
}

  function alterarCilindroCompactacao(index, valorDigitado) {
  iniciarEdicao();
  const cilindro = buscarCilindroPorNumero(cilindros, valorDigitado);

  setEnsaio((atual) => {
    const compactacao = garantirCincoPontos(atual.compactacao || []);

    compactacao[index] = {
  ...(compactacao[index] || {}),
  cilindro: valorDigitado,
  cilindroNumero: valorDigitado,
  cilindroId: cilindro?.id || "",
  pesoCilindro: obterPesoCilindro(cilindro),
  volumeCilindro: obterVolumeCilindro(cilindro),
  alturaCilindro: obterAlturaCilindro(cilindro),
};

    const expansao = [...(atual.expansao || [])];

    if (expansao[index]) {
      expansao[index] = calcularLinhaExpansaoLocal(
        {
          ...expansao[index],
          cilindro: valorDigitado,
        },
        compactacao[index]
      );
    }

    return recalcularCompactacaoComResultadosCurva({
        ...atual,
        compactacao,
        expansao,
      });
  });
}

  function alterarCapsulaCompactacao(index, valorDigitado) {
    iniciarEdicao();
    const capsula = buscarCapsulaPorNumero(
      capsulas,
      valorDigitado,
      "higroscopica"
    );

    setEnsaio((atual) => {
      const compactacao = garantirCincoPontos(atual.compactacao || []);

      compactacao[index] = {
        ...(compactacao[index] || {}),
        capsula: valorDigitado,
        capsulaNumero: valorDigitado,
        capsulaId: capsula?.id || "",
        pesoCapsula: obterPesoCapsula(capsula),
      };

      const proximo = { ...atual, compactacao };
      return numeroDecimal(atual.umidadeMedia) !== null
        ? recalcularLinhasCompactacaoPorUmidadeMedia(proximo)
        : proximo;
    });
  }

  function alterarCapsulaHigroscopica(index, valorDigitado) {
    iniciarEdicao();
    const capsula = buscarCapsulaPorNumero(
      capsulas,
      valorDigitado,
      "higroscopica"
    );

    setEnsaio((atual) => {
      const umidadeHigroscopica = garantirDuasUmidadesHigroscopicas(
        atual.granulometria?.umidadeHigroscopica || []
      );

      umidadeHigroscopica[index] = calcularUmidadePorCapsula({
        ...(umidadeHigroscopica[index] || {}),
        capsula: valorDigitado,
        capsulaNumero: valorDigitado,
        capsulaId: capsula?.id || "",
        pesoCapsula: obterPesoCapsula(capsula),
      });

      return {
        ...atual,
        granulometria: {
          ...atual.granulometria,
          umidadeHigroscopica,
        },
      };
    });
  }

  function recalcularLinhaCompactacao(index, parcial) {
    iniciarEdicao();
    setEnsaio((atual) => {
      const compactacao = garantirCincoPontos(atual.compactacao || []);

      compactacao[index] = {
        ...(compactacao[index] || {}),
        ...parcial,
      };

      const proximo = { ...atual, compactacao };
      if (numeroDecimal(atual.umidadeMedia) !== null) {
        return recalcularLinhasCompactacaoPorUmidadeMedia(proximo);
      }

      const linhaAtual = compactacao[index] || {};
      const quantidadeDigitosMassa = String(
        linhaAtual.pesoSoloUmidoMolde || ""
      ).replace(/\D/g, "").length;
      const possuiCilindro = Boolean(
        linhaAtual.cilindroNumero || linhaAtual.cilindro
      );

      if (quantidadeDigitosMassa < 4 || !possuiCilindro) {
        return proximo;
      }

      compactacao[index] = calcularLinhaCompactacaoLocal(linhaAtual, {
        pesoMaterialUmido: atual.pesoMaterialUmido,
        pesoMaterialSeco: atual.pesoMaterialSeco,
        umidadeMedia: atual.umidadeMedia,
      });

      return { ...atual, compactacao };
    });
  }

  function temDadosUmidadeHigroscopica(ensaioAtual) {
    return garantirDuasUmidadesHigroscopicas(
      ensaioAtual.granulometria?.umidadeHigroscopica || []
    ).some((linha) =>
      [
        "capsula",
        "capsulaNumero",
        "capsulaId",
        "capsulaSoloAgua",
        "capsulaSolo",
        "agua",
        "pesoCapsula",
        "solo",
        "umidade",
      ].some((campo) => {
        const valor = linha?.[campo];
        return valor !== null && valor !== undefined && String(valor).trim() !== "";
      })
    );
  }

  function atualizarUmidadePontoCompactacao(index, parcial, limparUmidadeHigroscopica = false) {
    iniciarEdicao();
    const possuiNovoValor = Object.values(parcial).some(
      (valor) => valor !== null && valor !== undefined && String(valor).trim() !== ""
    );

    if (
      !limparUmidadeHigroscopica &&
      possuiNovoValor &&
      temDadosUmidadeHigroscopica(ensaio)
    ) {
      setConfirmacaoUmidadePonto({ index, parcial });
      return;
    }

    setEnsaio((atual) => {
      const compactacao = garantirCincoPontos(atual.compactacao || []);
      compactacao[index] = {
        ...(compactacao[index] || {}),
        ...parcial,
      };

      return limparUmidadeHigroscopica
        ? {
            ...atual,
            umidadeMedia: "",
            compactacao,
            granulometria: {
              ...atual.granulometria,
              umidadeHigroscopica: garantirDuasUmidadesHigroscopicas([]),
              umidadeMedia: "",
            },
          }
        : { ...atual, compactacao };
    });
  }

  function finalizarUmidadePontoCompactacao(index) {
    setEnsaio((atual) => {
      const compactacao = garantirCincoPontos(atual.compactacao || []);
      compactacao[index] = calcularUmidadePorCapsula(compactacao[index] || {});

      if (numeroDecimal(atual.umidadeMedia) === null) {
        return { ...atual, compactacao };
      }

      return recalcularLinhasCompactacaoPorUmidadeMedia({ ...atual, compactacao });
    });
  }

  function alterarAguaAdicionadaCompactacao(index, valor) {
    iniciarEdicao();
    if (aguaAdicionadaTimerRef.current) {
      clearTimeout(aguaAdicionadaTimerRef.current);
    }

    setEnsaio((atual) => {
      const compactacao = garantirCincoPontos(atual.compactacao || []);

      compactacao[index] = {
        ...(compactacao[index] || {}),
        aguaAdicionada: valor,
      };

      return {
        ...atual,
        aguaAdicionadaReferencia: null,
        compactacao,
      };
    });

    if (String(valor || "").replace(/\D/g, "").length < 3) return;

    aguaAdicionadaTimerRef.current = setTimeout(() => {
      setEnsaio((atual) => {
        const compactacao = garantirCincoPontos(atual.compactacao || []);

        compactacao[index] = {
          ...(compactacao[index] || {}),
          aguaAdicionada: valor,
        };

        return recalcularCompactacaoComResultadosCurva({
          ...atual,
          aguaAdicionadaReferencia: { index },
          compactacao,
        });
      });
      aguaAdicionadaTimerRef.current = null;
    }, 700);
  }


  function calcularLinhaExpansaoLocal(linha = {}, compactacaoLinha = {}) {
  const leituraInicial = numeroDecimal(linha.leituraInicial);
  const leituraFinal = numeroDecimal(linha.leituraFinal);

  const alturaCilindro = numeroDecimal(
    compactacaoLinha.alturaCilindro ||
      compactacaoLinha.altura ||
      compactacaoLinha.alturaCp ||
      compactacaoLinha.alturaCP
  );

  const diferenca =
    leituraInicial !== null && leituraFinal !== null
      ? leituraFinal - leituraInicial
      : null;

  const expansao =
    diferenca !== null && alturaCilindro !== null && alturaCilindro !== 0
      ? (diferenca / alturaCilindro) * 100
      : null;

  return {
    ...linha,
    alturaCilindro:
      alturaCilindro !== null ? formatarDecimal(arred(alturaCilindro, 2), 2) : "",
    diferenca:
      diferenca !== null ? formatarDecimal(arred(diferenca, 3), 3) : "",
    expansao:
      expansao !== null ? formatarDecimal(arred(expansao, 2), 2) : "",
  };
}

 function atualizarUmidadeHigroscopica(index, parcial) {
  iniciarEdicao();

  setEnsaio((atual) => {
    const umidadeHigroscopica = garantirDuasUmidadesHigroscopicas(
      atual.granulometria?.umidadeHigroscopica || []
    );

    umidadeHigroscopica[index] = {
      ...(umidadeHigroscopica[index] || {}),
      ...parcial,
    };

    return {
      ...atual,
      granulometria: {
        ...atual.granulometria,
        umidadeHigroscopica,
      },
    };
  });
}

function finalizarUmidadeHigroscopica(index) {
  setEnsaio((atual) => {
    const umidadeHigroscopica = garantirDuasUmidadesHigroscopicas(
      atual.granulometria?.umidadeHigroscopica || []
    );

    umidadeHigroscopica[index] = calcularUmidadePorCapsula(
      umidadeHigroscopica[index] || {}
    );

    const umidadesValidas = umidadeHigroscopica
      .map((linha) => numeroDecimal(linha.umidade))
      .filter((valor) => valor !== null);

    const umidadeMedia =
      umidadesValidas.length > 0
        ? umidadesValidas.reduce((total, valor) => total + valor, 0) /
          umidadesValidas.length
        : null;

    const umidadeMediaFormatada =
      umidadeMedia !== null ? formatarDecimal(arred(umidadeMedia, 1), 1) : "";

    const proximo = {
        ...atual,
        umidadeMedia: umidadeMediaFormatada,
        granulometria: {
          ...atual.granulometria,
          umidadeHigroscopica,
          umidadeMedia: umidadeMediaFormatada,
        },
      };

    const umidadeMediaAnterior = numeroDecimal(atual.umidadeMedia);
    const novaUmidadeMedia = numeroDecimal(umidadeMediaFormatada);
    const umidadeMediaMudou =
      novaUmidadeMedia !== null &&
      novaUmidadeMedia !== umidadeMediaAnterior;

    return umidadeMediaMudou
      ? recalcularLinhasCompactacaoPorUmidadeMedia(proximo)
      : proximo;
  });
}

async function salvar() {
  if (!editando) return;

  try {
    setSalvando(true);
    setErro("");
    setAvisoAprovacao("");

    const user = auth.currentUser;

    if (!user) {
      setErro("Usuário não autenticado.");
      return;
    }

    const userSnap = await getDoc(doc(db, "users", user.uid));
    const userData = userSnap.data() || {};

    const tipoUsuario = String(userData.tipo || "").toLowerCase();

    const foiCriadoPorMim =
      ensaio?.createdByUid === user.uid ||
      ensaio?.createdBy?.uid === user.uid;

    const podeEditarDireto =
      tipoUsuario === "admin" || foiCriadoPorMim;

    const prepararEnsaioParaSalvar = (estado) => {
      // A mesclagem pode recuperar linhas remotas sem os dados preenchidos
      // pelo cadastro ao abrir a tela. Reconstitui esses dados antes do cálculo.
      const compactacaoBase = garantirCincoPontos(estado.compactacao || []).map((linha) => {
        const cilindro = buscarCilindroPorNumero(
          cilindros,
          linha.cilindroNumero || linha.cilindro || linha.numeroCilindro || ""
        ) || cilindros.find((item) => linha.cilindroId && item.id === linha.cilindroId);
        return {
          ...linha,
          pesoCilindro: linha.pesoCilindro || obterPesoCilindro(cilindro),
          volumeCilindro: linha.volumeCilindro || obterVolumeCilindro(cilindro),
          alturaCilindro: linha.alturaCilindro || obterAlturaCilindro(cilindro),
        };
      });
      const linhasComCilindro = compactacaoBase
        .slice(0, 5)
        .filter((linha) => linha.cilindroNumero || linha.cilindro);

      const expansaoSincronizada = linhasComCilindro.map((linha, index) =>
        calcularLinhaExpansaoLocal(
          {
            ...(estado.expansao?.[index] || {}),
            cilindro: linha.cilindroNumero || linha.cilindro || "",
          },
          linha
        )
      );

      const cbrSincronizado = linhasComCilindro.map((linha, index) => ({
        ...(estado.cbr?.[index] || {}),
        cilindro: linha.cilindroNumero || linha.cilindro || "",
        leituras:
          estado.cbr?.[index]?.leituras?.length
            ? estado.cbr[index].leituras
            : penetracoesCBR.map((ponto) => ({
                mm: ponto.mm,
                pressao: "",
                leitura: "",
              })),
      }));

      return recalcularCompactacaoCompleta({
        ...estado,
        compactacao: compactacaoBase,
        expansao: expansaoSincronizada,
        cbr: cbrSincronizado,
      });
    };

    const ensaioRecalculado = prepararEnsaioParaSalvar(ensaio);

    const usuarioRegistro = {
      uid: user.uid,
      nome: userData.nome || user.displayName || user.email || "",
      email: user.email || "",
      tipo: tipoUsuario,
    };

    const dadosParaSalvar = {
      ...ensaioRecalculado,
      resultados: ensaioRecalculado.resultados,
      atualizadoEm: new Date(),
      updatedBy: usuarioRegistro,
    };

    if (podeEditarDireto) {
      const ensaioRef = doc(db, COLLECTION_COMPACTACAO, compactacaoId);
      const dadosMescladosSalvos = await atualizarDocumentoComMesclagem({
        db,
        referencia: ensaioRef,
        original: ensaioOriginal,
        atual: ensaio,
        preparar: prepararEnsaioParaSalvar,
        metadados: {
          atualizadoEm: new Date(),
          updatedBy: usuarioRegistro,
        },
      });

      setEnsaio(dadosMescladosSalvos);
      setEnsaioOriginal(dadosMescladosSalvos);
      setEditando(false);
      return;
    }

    const camposEditados = extrairCamposAlterados(ensaioOriginal || {}, ensaio);
    const alteracoesSolicitadas = Object.keys(camposEditados).reduce(
      (alteracoes, campo) => {
        alteracoes[campo] = dadosParaSalvar[campo];
        return alteracoes;
      },
      {
        atualizadoEm: dadosParaSalvar.atualizadoEm,
        updatedBy: dadosParaSalvar.updatedBy,
      }
    );

    await addDoc(collection(db, "aprovacoes"), aplicarTenantAtual({
      tipo: "compactacao",
      titulo: `Alteração de ensaio de compactação ${ensaio.codigo || ensaio.registroNumero || ""}`,
      colecao: COLLECTION_COMPACTACAO,
      registroId: compactacaoId,
      dadosSolicitados: alteracoesSolicitadas,
      solicitadoPor: usuarioRegistro,
      status: "pendente",
      criadoEm: new Date(),
    }));

    setAvisoAprovacao("Alteração enviada para aprovação do administrador.");
    setEnsaio(ensaioOriginal);
    setEditando(false);
  } catch (err) {
    console.error(err);
    setErro("Erro ao salvar ou solicitar alteração.");
  } finally {
    setSalvando(false);
  }
}

function cancelarAlteracoes() {
  setEnsaio(ensaioOriginal);
  setEditando(false);
}

  const dadosCompactacao = useMemo(
    () =>
      (ensaio?.compactacao || [])
        .map((ponto) => ({
          umidade: numero(ponto.umidadeCalculada || ponto.umidade),
          densidadeSeca: numero(ponto.densidadeSeca),
          densidadeUmida: numero(ponto.densidadeUmida),
          densidadeConvertida: numero(ponto.densidadeConvertida),
        }))
        .filter(
          (ponto) =>
            ponto.umidade !== null &&
            (ponto.densidadeSeca !== null ||
              ponto.densidadeUmida !== null ||
              ponto.densidadeConvertida !== null)
        ),
    [ensaio?.compactacao]
  );

  const dadosGraficoCompactacao = useMemo(
    () =>
      (ensaio?.compactacao || [])
        .map((ponto) => ({
          umidade: numeroDecimal(ponto.umidadeCalculada),
          densidadeSeca: numeroDecimal(ponto.densidadeSeca),
        }))
        .filter(
          (ponto) => ponto.umidade !== null && ponto.densidadeSeca !== null
        )
        .sort((a, b) => a.umidade - b.umidade),
    [ensaio?.compactacao]
  );

  const dadosCurvaCompactacaoSuavizada = useMemo(
    () =>
      gerarCurvaSplineNatural(
        dadosGraficoCompactacao.map((ponto) => ({
          x: ponto.umidade,
          y: ponto.densidadeSeca,
        }))
      ),
    [dadosGraficoCompactacao]
  );

  const resultadoGraficoOtimo = useMemo(
    () => ({
      umidadeOtima: numeroDecimal(ensaio?.resultados?.umidadeOtima),
      densidadeMaxima: numeroDecimal(ensaio?.resultados?.densidadeMaxima),
    }),
    [ensaio?.resultados?.umidadeOtima, ensaio?.resultados?.densidadeMaxima]
  );

  const escalaDensidadeGrafico = useMemo(
    () =>
      calcularTicksDensidade(
        dadosGraficoCompactacao,
        resultadoGraficoOtimo.densidadeMaxima
      ),
    [dadosGraficoCompactacao, resultadoGraficoOtimo.densidadeMaxima]
  );

  const dominioUmidadeGrafico = useMemo(
    () =>
      calcularDominioUmidade(
        dadosGraficoCompactacao,
        resultadoGraficoOtimo.umidadeOtima
      ),
    [dadosGraficoCompactacao, resultadoGraficoOtimo.umidadeOtima]
  );

  const dadosCbr = useMemo(
    () =>
      (ensaio?.cbr || [])
        .map((linha) => ({
          cilindro: linha.cilindro || linha.id,
          isc: numero(linha.isc),
        }))
        .filter((linha) => linha.isc !== null),
    [ensaio?.cbr]
  );

  const cilindrosCompactacao = useMemo(() => {
  return (ensaio?.compactacao || [])
    .slice(0, 5)
    .map((linha) => {
      const cilindro =
        linha.cilindroNumero ||
        linha.cilindro ||
        linha.numeroCilindro ||
        "";
      const cilindroBanco = buscarCilindroPorNumero(cilindros, cilindro);

      return {
        cilindro,
        alturaCilindro:
          linha.alturaCilindro ||
          cilindroBanco?.altura ||
          cilindroBanco?.alturaCilindro ||
          cilindroBanco?.alturaCp ||
          cilindroBanco?.alturaCP ||
          "",
      };
    })
    .filter((linha) => linha.cilindro !== "");
}, [ensaio?.compactacao, cilindros]);

const expansaoComCilindrosCompactacao = useMemo(() => {
  return cilindrosCompactacao.map((item, index) => {
    const compactacaoLinha = {
      ...(ensaio?.compactacao?.[index] || {}),
      alturaCilindro: item.alturaCilindro,
    };

    return calcularLinhaExpansaoLocal(
      {
        ...(ensaio?.expansao?.[index] || {}),
        cilindro: item.cilindro,
      },
      compactacaoLinha
    );
  });
}, [cilindrosCompactacao, ensaio?.expansao, ensaio?.compactacao]);

const dadosExpansao = useMemo(
  () =>
    (expansaoComCilindrosCompactacao || [])
      .map((linha) => ({
        cilindro: linha.cilindro || linha.id,
        expansao: numero(linha.expansao),
      }))
      .filter((linha) => linha.expansao !== null),
  [expansaoComCilindrosCompactacao]
);

const cbrComCilindrosCompactacao = useMemo(() => {
  return cilindrosCompactacao.map((item, index) =>
    calcularLinhaCbrLocal(
      {
        ...(ensaio?.cbr?.[index] || {}),
        cilindro: item.cilindro,
        leituras:
          ensaio?.cbr?.[index]?.leituras?.length
            ? ensaio.cbr[index].leituras
            : penetracoesCBR.map((ponto) => ({
                mm: ponto.mm,
                pressao: "",
                leitura: "",
              })),
      },
      ensaio
    )
  );
}, [cilindrosCompactacao, ensaio]);

const penetracaoIscGrafico = useMemo(() => {
  return selecionarCampoIsc(cbrComCilindrosCompactacao);
}, [cbrComCilindrosCompactacao]);

const escalaIscGrafico = useMemo(
  () =>
    criarEscalaBanda(
      cbrComCilindrosCompactacao.map((linha) => numeroDecimal(linha[penetracaoIscGrafico])),
      64,
      98,
      2
    ),
  [cbrComCilindrosCompactacao, penetracaoIscGrafico]
);

const escalaExpansaoGrafico = useMemo(
  () =>
    criarEscalaBanda(
      expansaoComCilindrosCompactacao.map((linha) => numeroDecimal(linha.expansao)),
      2,
      36,
      0.2
    ),
  [expansaoComCilindrosCompactacao]
);

const dadosGraficoCurvas = useMemo(
  () => {
    const pontosBase = (ensaio?.compactacao || [])
      .slice(0, 5)
      .map((ponto, index) => {
        const isc = numeroDecimal(cbrComCilindrosCompactacao[index]?.[penetracaoIscGrafico]);
        const expansao = numeroDecimal(expansaoComCilindrosCompactacao[index]?.expansao);

        return {
          umidade: numeroDecimal(ponto.umidadeCalculada || ponto.umidade),
          densidadeSeca: numeroDecimal(ponto.densidadeSeca),
          isc,
          expansao,
          iscPlot: escalaIscGrafico.toPlot(isc),
          expansaoPlot: escalaExpansaoGrafico.toPlot(expansao),
        };
      })
      .filter(
        (ponto) =>
          ponto.umidade !== null &&
          (ponto.densidadeSeca !== null ||
            ponto.isc !== null ||
            ponto.expansao !== null)
      );

    const porUmidade = new Map();

    dadosCurvaCompactacaoSuavizada.forEach((ponto) => {
      porUmidade.set(ponto.umidade, { ...ponto });
    });

    pontosBase.forEach((ponto) => {
      porUmidade.set(ponto.umidade, {
        ...(porUmidade.get(ponto.umidade) || {}),
        ...ponto,
      });
    });

    return Array.from(porUmidade.values()).sort((a, b) => a.umidade - b.umidade);
  },
  [
    ensaio?.compactacao,
    cbrComCilindrosCompactacao,
    expansaoComCilindrosCompactacao,
    dadosCurvaCompactacaoSuavizada,
    escalaIscGrafico,
    escalaExpansaoGrafico,
    penetracaoIscGrafico,
  ]
);

const dominioUmidadeCurvas = useMemo(
  () => calcularDominioUmidade(dadosGraficoCurvas, resultadoGraficoOtimo.umidadeOtima),
  [dadosGraficoCurvas, resultadoGraficoOtimo.umidadeOtima]
);

const ticksUmidadeCurvas = useMemo(
  () => criarTicksIntervalo(dominioUmidadeCurvas[0], dominioUmidadeCurvas[1], 2),
  [dominioUmidadeCurvas]
);

const ticksUmidadeSecundarios = useMemo(
  () => criarTicksIntervalo(dominioUmidadeCurvas[0], dominioUmidadeCurvas[1], 0.5),
  [dominioUmidadeCurvas]
);

const ticksDensidadeSecundarios = useMemo(
  () =>
    criarTicksIntervalo(
      escalaDensidadeGrafico.domain[0],
      escalaDensidadeGrafico.domain[1],
      0.01
    ),
  [escalaDensidadeGrafico]
);

const referenciasCurvasOtimas = useMemo(() => {
  const umidadeOtima = resultadoGraficoOtimo.umidadeOtima;
  if (umidadeOtima === null || dadosGraficoCurvas.length < 2) {
    return { umidadeReferencia: null, iscPlot: null, expansaoPlot: null };
  }

  function interpolar(campo) {
    const pontos = dadosGraficoCurvas
      .map((ponto) => ({ x: ponto.umidade, y: ponto[campo] }))
      .filter((ponto) => ponto.x !== null && ponto.y !== null)
      .sort((a, b) => a.x - b.x);

    if (!pontos.length) return null;

    const exato = pontos.find((ponto) => ponto.x === umidadeOtima);
    if (exato) return exato.y;

    for (let index = 0; index < pontos.length - 1; index += 1) {
      const atual = pontos[index];
      const proximo = pontos[index + 1];
      if (umidadeOtima >= atual.x && umidadeOtima <= proximo.x) {
        const proporcao = (umidadeOtima - atual.x) / (proximo.x - atual.x || 1);
        return atual.y + (proximo.y - atual.y) * proporcao;
      }
    }

    return null;
  }

  return {
    umidadeReferencia: umidadeOtima,
    iscPlot: interpolar("iscPlot"),
    expansaoPlot: interpolar("expansaoPlot"),
  };
}, [dadosGraficoCurvas, resultadoGraficoOtimo.umidadeOtima]);

  if (loading) {
    return (
      <>
        <Navbar />
        <Box sx={{ minHeight: "70vh", display: "grid", placeItems: "center" }}>
          <CircularProgress />
        </Box>
      </>
    );
  }

  if (!ensaio) {
    return (
      <>
        <Navbar />
        <Box sx={{ p: 4 }}>
          <Typography>Ensaio não encontrado.</Typography>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => history.goBack()}
          >
            Voltar
          </Button>
        </Box>
      </>
    );
  }

  if (modoPrint) {
    return (
      <RelatorioCompactacaoPrint
        ensaio={ensaio}
        onVoltar={() => setModoPrint(false)}
      />
    );
  }

  const capsulasHigroscopicas = capsulas.filter(
    (item) => item.tipo === "higroscopica"
  );

  return (
    <>
      <Navbar />
      <CabecalhoDetalhes
        titulo="Detalhes do Ensaio de Compactação"
        subtitulo={`${metadadosCabecalho.rq}   Rev.${metadadosCabecalho.revisao} - ${formatarDataCabecalho(ensaio.dataEnsaio)}`}
      >
            <Button
  variant="outlined"
  startIcon={<ArrowBackIcon />}
  onClick={() => history.push("/app/ensaio-compactacao")}
  disabled={editando || salvando}
>
              Voltar
            </Button>

            <Button
              variant="outlined"
              startIcon={<PrintIcon />}
              onClick={() => setModoPrint(true)}
              disabled={editando}
            >
              Relatório
            </Button>
<>
  <Button
    variant="contained"
    startIcon={<SaveIcon />}
    onClick={salvar}
    disabled={!editando || salvando}
  >
    {salvando
      ? "Salvando..."
      : String(localStorage.getItem("tipoUsuario") || "").toLowerCase() === "admin" ||
        ensaio?.createdByUid === auth.currentUser?.uid ||
        ensaio?.createdBy?.uid === auth.currentUser?.uid
        ? "Salvar"
        : "Solicitar alteração"}
  </Button>

  <Button
    variant="outlined"
    onClick={cancelarAlteracoes}
    disabled={!editando || salvando}
  >
    Cancelar alterações
  </Button>
</>
            
      </CabecalhoDetalhes>

      <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1180, mx: "auto" }}>
{avisoAprovacao && (
  <Alert severity="info" sx={{ mb: 2 }}>
    {avisoAprovacao}
  </Alert>
)}

{erro && (
  <Alert severity="error" sx={{ mb: 2 }}>
    {erro}
  </Alert>
)}
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={1.25}
          mb={2}
          sx={
              !editando
                ? {
                    "& .MuiOutlinedInput-root": { backgroundColor: "#f8fafc" },
                  }
                : {}
            }
        >
          <TextField label="Registro Nº" size="small" value={ensaio.registroNumero || ""} onChange={(e) => atualizar({ registroNumero: e.target.value })} sx={{ flex: 1 }} />
          <TextField label="Data do ensaio" size="small" type="date" InputLabelProps={{ shrink: true }} value={ensaio.dataEnsaio || ""} onChange={(e) => atualizar({ dataEnsaio: e.target.value })} sx={{ flex: 1 }} />
          <TextField label="Material" size="small" value={ensaio.material || ""} onChange={(e) => atualizar({ material: e.target.value })} sx={{ flex: 1.4 }} />
          <TextField label="Camada/Estudo" size="small" value={ensaio.camadaEstudo || ""} onChange={(e) => atualizar({ camadaEstudo: e.target.value })} sx={{ flex: 1.2 }} />
          <TextField label="Local de coleta" size="small" value={ensaio.localColeta || ""} onChange={(e) => atualizar({ localColeta: e.target.value })} sx={{ flex: 1.4 }} />
        </Stack>

        <Paper sx={{ border: "1px solid #d7dde8", boxShadow: "none", overflowX: "auto" }}>
          <Tabs
            value={tab}
            onChange={(event, novoValor) => setTab(novoValor)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ px: 2, borderBottom: "1px solid #e2e8f0" }}
          >
            <Tab label="Compactação" />
            <Tab label="CBR e Expansão" />
            <Tab label="Granulometria" />
            <Tab label="Limites Físicos" />
            <Tab label="Substituição do Solo" />
          </Tabs>

          <Box
            sx={{
  p: 2,
  ...(!editando
    ? {
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#f8fafc",
        },
      }
    : {}),
}}
          >
            {false && (
              <Stack spacing={2}>
                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  <TextField
                    label="Código"
                    value={ensaio.codigo || ""}
                    onChange={(e) => atualizar({ codigo: e.target.value })}
                    fullWidth
                  />

                  <TextField
                    label="Registro Nº"
                    value={ensaio.registroNumero || ""}
                    onChange={(e) =>
                      atualizar({ registroNumero: e.target.value })
                    }
                    fullWidth
                  />

                  <TextField
                    label="Data do ensaio"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={ensaio.dataEnsaio || ""}
                    onChange={(e) =>
                      atualizar({ dataEnsaio: e.target.value })
                    }
                    fullWidth
                  />
                </Stack>

                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  <TextField
                    label="Empresa"
                    value={ensaio.empresa || ensaio.cliente || ""}
                    onChange={(e) =>
                      atualizar({
                        empresa: e.target.value,
                        cliente: e.target.value,
                      })
                    }
                    fullWidth
                  />

                  <TextField
                    label="Obra"
                    value={ensaio.obra || ""}
                    onChange={(e) => atualizar({ obra: e.target.value })}
                    fullWidth
                  />
                </Stack>

                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  <TextField
                    label="Camada/Estudo"
                    value={ensaio.camadaEstudo || ""}
                    onChange={(e) =>
                      atualizar({ camadaEstudo: e.target.value })
                    }
                    fullWidth
                  />

                  <TextField
                    label="Material"
                    value={ensaio.material || ""}
                    onChange={(e) => atualizar({ material: e.target.value })}
                    fullWidth
                  />

                  <TextField
                    label="Local de coleta"
                    value={ensaio.localColeta || ""}
                    onChange={(e) =>
                      atualizar({ localColeta: e.target.value })
                    }
                    fullWidth
                  />
                </Stack>

                <TextField
                  label="Observação"
                  value={ensaio.observacao || ""}
                  onChange={(e) => atualizar({ observacao: e.target.value })}
                  multiline
                  minRows={3}
                  fullWidth
                />
              </Stack>
            )}

            {tab === 0 && (
              <Stack spacing={2}>
                <Typography fontWeight={700}>Dados de Compactação</Typography>

                <Paper
                  sx={{
                    overflow: "auto",
                    border: "1px solid #d7dde8",
                    boxShadow: "none",
                    borderRadius: "8px",
                  }}
                >
                  <Table
                    size="small"
                    sx={{
                      width: "100%",
                      minWidth: 0,
                      tableLayout: "fixed",
                      "& td, & th": {
                        borderColor: "#d7dde8",
                        fontSize: 11,
                        color: "#334155",
                        px: "3px",
                        py: "4px",
                      },
                      "& td:first-of-type": {
                        fontWeight: 700,
                        color: "#0f172a",
                        backgroundColor: "#fbfdff",
                      },
                      "& .MuiTextField-root": {
                        minWidth: 0,
                      },
                      "& .MuiOutlinedInput-root": {
                        minWidth: 0,
                      },
                      "& .MuiInputBase-input": {
                        minWidth: 0,
                        px: "3px",
                        fontSize: 11,
                      },
                    }}
                  >
                    <colgroup>
                      <col style={{ width: 185 }} />
                      <col style={{ width: 118 }} />
                      <col style={{ width: 118 }} />
                      <col style={{ width: 118 }} />
                      <col style={{ width: 118 }} />
                      <col style={{ width: 118 }} />
                      <col style={{ width: 190 }} />
                      <col style={{ width: 110 }} />
                    </colgroup>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ ...cellSx, fontWeight: 700 }} colSpan={6}>
                          UMIDADE DE CADA PONTO
                        </TableCell>
                        <TableCell sx={{ ...cellSx, fontWeight: 700 }} colSpan={2}>
                          UMIDADE HIGROSCÓPICA
                        </TableCell>
                      </TableRow>

                      {[
                        ["CÁPSULA Nº", "capsula"],
                        ["CÁPSULA + SOLO + ÁGUA", "capsulaSoloAgua"],
                        ["CÁPSULA + SOLO", "capsulaSolo"],
                        ["ÁGUA", "agua"],
                        ["CÁPSULA", "pesoCapsula"],
                        ["SOLO", "solo"],
                        ["% UMIDADE", "umidade"],
                      ].map(([titulo, campo], campoIndex) => (
                        <TableRow key={campo}>
                          <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>
                            {titulo}
                          </TableCell>

                          {(ensaio.compactacao || []).slice(0, 5).map((linha, index) => (
                            <TableCell key={index} sx={cellSx}>
                              {campo === "capsula" ? (
                                campoTabela(
                                  linha.capsulaNumero ?? linha.capsula ?? "",
                                  (valor) => alterarCapsulaCompactacao(index, valor),
                                  {
                                    inputProps: {
                                      maxLength: 3,
                                      style: { textAlign: "center", fontSize: 12 },
                                    },
                                  }
                                )
                              ) : campo === "agua" ||
                                campo === "pesoCapsula" ||
                                campo === "solo" ||
                                campo === "umidade" ? (
                                linha[campo] || "-"
                              ) : (
                                campoTabela(
                                  linha[campo],
                                  (valor) =>
                                    atualizarUmidadePontoCompactacao(index, {
                                      [campo]: valor,
                                    }),
                                  {
                                    salvarAoSair: true,
                                    onBlur: () => finalizarUmidadePontoCompactacao(index),
                                  }
                                )
                              )}
                            </TableCell>
                          ))}

                          <TableCell
                            colSpan={2}
                            sx={{
                              ...cellSx,
                              p: 0,
                              backgroundImage:
                                "linear-gradient(to right, transparent calc(50% - 0.5px), #d7dde8 calc(50% - 0.5px), #d7dde8 calc(50% + 0.5px), transparent calc(50% + 0.5px))",
                            }}
                          >
                            <Box
                              sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                                minHeight: 30,
                                columnGap: 0,
                              }}
                            >
                              {garantirDuasUmidadesHigroscopicas(
                                ensaio.granulometria?.umidadeHigroscopica || []
                              ).map((linha, index) => (
                                <Box
                                  key={index}
                                  sx={{
                                    minWidth: 0,
                                    px: "4px",
                                    py: "4px",
                                    "&:first-of-type": {
                                      pr: "7px",
                                    },
                                    "&:last-of-type": {
                                      pl: "7px",
                                    },
                                  }}
                                >
                                  {campo === "capsula" ? (
                                    campoTabela(
                                      linha.capsulaNumero ?? linha.capsula ?? "",
                                      (valor) => alterarCapsulaHigroscopica(index, valor),
                                      {
                                        salvarAoSair: true,
                                        onBlur: () => finalizarUmidadeHigroscopica(index),
                                        inputProps: {
                                          maxLength: 3,
                                          style: { textAlign: "center", fontSize: 12 },
                                          "data-enter-row": campoIndex,
                                          "data-enter-col": `umidade-higroscopica-${index}`,
                                        },
                                      }
                                    )
                                  ) : campo === "agua" ||
                                    campo === "pesoCapsula" ||
                                    campo === "solo" ||
                                    campo === "umidade" ? (
                                    linha[campo] || "-"
                                  ) : (
                                    campoTabela(
                                      linha[campo],
                                      (valor) =>
                                        atualizarUmidadeHigroscopica(index, {
                                          [campo]: valor,
                                        }),
                                      {
                                        salvarAoSair: true,
                                        onBlur: () => finalizarUmidadeHigroscopica(index),
                                        inputProps: {
                                          "data-enter-row": campoIndex,
                                          "data-enter-col": `umidade-higroscopica-${index}`,
                                        },
                                      }
                                    )
                                  )}
                                </Box>
                              ))}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}

                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>UMIDADE MÉDIA</TableCell>
                        <TableCell colSpan={5}></TableCell>
                        <TableCell colSpan={2} sx={cellSx}>
                          {ensaio.umidadeMedia || "-"}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>UMIDADE CALCULADA</TableCell>
                        {(ensaio.compactacao || []).slice(0, 5).map((linha, index) => (
                          <TableCell key={index} sx={cellSx}>
                            {linha.umidadeCalculada || "-"}
                          </TableCell>
                        ))}
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>PESO MATERIAL ÚMIDO g</TableCell>
                        <TableCell sx={{ p: 0.5 }}>
                          <Box sx={{ display: "grid", gap: 0.5 }}>
                            {campoTabela(ensaio.pesoMaterialUmido, (valor) =>
                              atualizar(
                                { pesoMaterialUmido: valor },
                                { liberarResultadosCurva: true }
                              )
                            )}
                            <Box sx={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) 34px", gap: 0.5, alignItems: "center" }}>
                              <Typography sx={{ fontSize: 9, fontWeight: 700, lineHeight: 1, whiteSpace: "nowrap" }}>
                                % ÁGUA ADIC.
                              </Typography>
                              {campoTabela(
                                ensaio.percentualAguaAdicionadaPadrao,
                                (valor) =>
                                  atualizar(
                                    { percentualAguaAdicionadaPadrao: valor },
                                    { liberarResultadosCurva: true }
                                  ),
                                {
                                  inputProps: {
                                    maxLength: 1,
                                    style: { textAlign: "center", fontSize: 12, paddingLeft: 1, paddingRight: 1 },
                                  },
                                }
                              )}
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>ÁGUA ADICIONADA (g)</TableCell>
                        {(ensaio.compactacao || []).slice(0, 5).map((linha, index) => (
                          <TableCell key={index}>
                            {campoTabela(linha.aguaAdicionada, (valor) =>
                              alterarAguaAdicionadaCompactacao(index, valor)
                            )}
                          </TableCell>
                        ))}
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>PESO MATERIAL SECO g</TableCell>
                        <TableCell sx={cellSx}>
                          {ensaio.pesoMaterialSeco || "-"}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>% ÁGUA ADICIONADA</TableCell>
                        {(ensaio.compactacao || []).slice(0, 5).map((linha, index) => (
                          <TableCell key={index} sx={cellSx}>
                            {linha.percentualAguaAdicionada || "-"}
                          </TableCell>
                        ))}
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>% MATERIAL RET. PEN. Nº 4</TableCell>
                        <TableCell>
                          {campoTabela(ensaio.percentualRetidoPeneira4, (valor) =>
                            atualizar({ percentualRetidoPeneira4: valor })
                          )}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>Nº DO CILINDRO</TableCell>
                        {(ensaio.compactacao || []).slice(0, 5).map((linha, index) => (
                          <TableCell key={index}>
                            {campoTabela(
                              linha.cilindroNumero ?? linha.cilindro ?? "",
                              (valor) => alterarCilindroCompactacao(index, valor),
                              {
                                inputProps: {
                                  maxLength: 3,
                                  style: { textAlign: "center", fontSize: 12 },
                                },
                              }
                            )}
                          </TableCell>
                        ))}
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>ESPESSURA DO DISCO mm</TableCell>
                        <TableCell>
                          {campoTabela(ensaio.espessuraDisco, (valor) =>
                            atualizar({ espessuraDisco: valor })
                          )}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>MASSA DO CILINDRO</TableCell>
                        {(ensaio.compactacao || []).slice(0, 5).map((linha, index) => (
                          <TableCell key={index} sx={cellSx}>
                            {linha.pesoCilindro || "-"}
                          </TableCell>
                        ))}
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>CAMADAS</TableCell>
                        <TableCell>
                          {campoTabela(ensaio.camadas, (valor) =>
                            atualizar({ camadas: valor })
                          )}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>MASSA + SOLO + ÁGUA</TableCell>
                        {(ensaio.compactacao || []).slice(0, 5).map((linha, index) => (
                          <TableCell key={index}>
                            {campoTabela(
                              linha.pesoSoloUmidoMolde,
                              (valor) => recalcularLinhaCompactacao(index, {
                                pesoSoloUmidoMolde: valor.replace(/\D/g, "").slice(0, 5),
                              }),
                              {
                                inputProps: {
                                  maxLength: 5,
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                },
                              }
                            )}
                          </TableCell>
                        ))}
                        <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>Nº DE GOLPES</TableCell>
                        <TableCell>
                          {campoTabela(ensaio.numeroGolpes, (valor) =>
                            atualizar({ numeroGolpes: valor })
                          )}
                        </TableCell>
                      </TableRow>

                      {[
                        ["SOLO + ÁGUA", "soloAgua"],
                        ["VOLUME DO CILINDRO", "volumeCilindro"],
                        ["DENSIDADE ÚMIDA", "densidadeUmida"],
                        ["DENSIDADE CONVERTIDA", "densidadeConvertida"],
                        ["DENSIDADE SECA", "densidadeSeca"],
                      ].map(([titulo, campo]) => (
                        <TableRow key={campo}>
                          <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>{titulo}</TableCell>

                          {(ensaio.compactacao || []).slice(0, 5).map((linha, index) => (
                            <TableCell key={index} sx={cellSx}>
                              {campo === "volumeCilindro"
                                ? linha.volumeCilindro || "-"
                                : linha[campo] || "-"}
                            </TableCell>
                          ))}

                          <TableCell colSpan={2}></TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>

                <Paper
                  sx={{
                    p: 2,
                    border: "1px solid #d7dde8",
                    boxShadow: "none",
                    borderRadius: "8px",
                  }}
                >
                  <Typography
                    fontWeight={700}
                    textAlign="center"
                    mb={1}
                    sx={{ color: "#0f172a" }}
                  >
                    CURVA DE COMPACTAÇÃO E CBR
                  </Typography>

                  {dadosGraficoCurvas.length ? (
                    <ResponsiveContainer width="100%" height={520}>
                      <LineChart
                        data={dadosGraficoCurvas}
                        margin={{ top: 20, right: 95, bottom: 80, left: 85 }}
                      >
                        <CartesianGrid stroke="#cbd5e1" strokeDasharray="3 3" />
                        {ticksUmidadeSecundarios
                          .filter((tick) => !ticksUmidadeCurvas.includes(tick))
                          .map((tick) => (
                            <ReferenceLine
                              key={`grid-x-${tick}`}
                              yAxisId="densidade"
                              x={tick}
                              stroke="#e2e8f0"
                              strokeWidth={0.6}
                              ifOverflow="extendDomain"
                            />
                          ))}
                        {ticksDensidadeSecundarios
                          .filter((tick) => !escalaDensidadeGrafico.ticks.includes(tick))
                          .map((tick) => (
                            <ReferenceLine
                              key={`grid-y-${tick}`}
                              yAxisId="densidade"
                              y={tick}
                              stroke="#e2e8f0"
                              strokeWidth={0.6}
                              ifOverflow="extendDomain"
                            />
                          ))}
                        <XAxis
                          type="number"
                          dataKey="umidade"
                          name="Umidade"
                          unit="%"
                          domain={dominioUmidadeCurvas}
                          ticks={ticksUmidadeCurvas}
                          tick={{ textAnchor: "middle" }}
                          tickFormatter={(valor) =>
                            Number(valor).toLocaleString("pt-BR", {
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1,
                            })
                          }
                          label={{
                            value: "Umidade (%)",
                            position: "insideBottom",
                            offset: -52,
                            textAnchor: "middle",
                          }}
                        />
                        <YAxis
                          yAxisId="densidade"
                          type="number"
                          dataKey="densidadeSeca"
                          name="Densidade seca"
                          domain={escalaDensidadeGrafico.domain}
                          ticks={escalaDensidadeGrafico.ticks}
                          tick={{ textAnchor: "end" }}
                          tickFormatter={(valor) =>
                            Number(valor).toLocaleString("pt-BR", {
                              minimumFractionDigits: 3,
                              maximumFractionDigits: 3,
                            })
                          }
                          label={{
                            value: "Densidade Seca (g/cm³)",
                            angle: -90,
                            position: "left",
                            textAnchor: "middle",
                            dx: -35,
                          }}
                        />
                        <YAxis
                          yAxisId="isc"
                          orientation="right"
                          type="number"
                          name="I.S.C."
                          domain={escalaIscGrafico.domain}
                          ticks={escalaIscGrafico.ticks}
                          width={42}
                          tick={{ textAnchor: "start" }}
                          tickFormatter={(valor) =>
                            escalaIscGrafico.fromPlot(valor).toLocaleString("pt-BR", {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 1,
                            })
                          }
                          label={{
                            value: "I.S.C. (%)",
                            angle: -90,
                            position: "insideRight",
                            textAnchor: "middle",
                            fill: "#7b1fa2",
                          }}
                        />
                        <YAxis
                          yAxisId="expansao"
                          orientation="right"
                          type="number"
                          name="Expansão"
                          domain={escalaExpansaoGrafico.domain}
                          ticks={escalaExpansaoGrafico.ticks}
                          width={50}
                          tick={{ textAnchor: "start" }}
                          tickFormatter={(valor) =>
                            escalaExpansaoGrafico.fromPlot(valor).toLocaleString("pt-BR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 3,
                            })
                          }
                          label={{
                            value: "Exp. (%)",
                            angle: -90,
                            position: "outsideRight",
                            textAnchor: "middle",
                            fill: "#ef6c00",
                          }}
                        />
                        <ChartTooltip
                          formatter={(valor, nome, props) => {
                            const real =
                              nome === "I.S.C."
                                ? props.payload?.isc
                                : nome === "Expansão"
                                ? props.payload?.expansao
                                : valor;
                            const casas =
                              nome === "Densidade seca"
                                ? 3
                                : nome === "Expansão"
                                ? 3
                                : 1;
                            return [
                              Number(real).toLocaleString("pt-BR", {
                                minimumFractionDigits: casas,
                                maximumFractionDigits: casas,
                              }),
                              nome,
                            ];
                          }}
                          labelFormatter={(valor) =>
                            `Umidade: ${Number(valor).toLocaleString("pt-BR", {
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1,
                            })}%`
                          }
                        />
                        {referenciasCurvasOtimas.umidadeReferencia !== null && (
                          <ReferenceLine
                            yAxisId="densidade"
                            segment={[
                              { x: referenciasCurvasOtimas.umidadeReferencia, y: escalaDensidadeGrafico.domain[0] },
                              {
                                x: referenciasCurvasOtimas.umidadeReferencia,
                                y: resultadoGraficoOtimo.densidadeMaxima || escalaDensidadeGrafico.domain[1],
                              },
                            ]}
                            stroke="#d32f2f"
                            strokeDasharray="6 4"
                          />
                        )}
                        {resultadoGraficoOtimo.densidadeMaxima !== null && resultadoGraficoOtimo.umidadeOtima !== null && (
                          <ReferenceLine
                            yAxisId="densidade"
                            segment={[
                              { x: dominioUmidadeCurvas[0], y: resultadoGraficoOtimo.densidadeMaxima },
                              { x: referenciasCurvasOtimas.umidadeReferencia, y: resultadoGraficoOtimo.densidadeMaxima },
                            ]}
                            stroke="#d32f2f"
                            strokeDasharray="6 4"
                          />
                        )}
                        {resultadoGraficoOtimo.umidadeOtima !== null && referenciasCurvasOtimas.umidadeReferencia !== null && referenciasCurvasOtimas.iscPlot !== null && (
                          <>
                            <ReferenceLine
                              yAxisId="isc"
                              x={referenciasCurvasOtimas.umidadeReferencia}
                              stroke="#d32f2f"
                              strokeDasharray="6 4"
                            />
                            <ReferenceLine
                              yAxisId="isc"
                              y={referenciasCurvasOtimas.iscPlot}
                              stroke="#d32f2f"
                              strokeDasharray="6 4"
                            />
                          </>
                        )}
                        {resultadoGraficoOtimo.umidadeOtima !== null && referenciasCurvasOtimas.umidadeReferencia !== null && referenciasCurvasOtimas.expansaoPlot !== null && (
                          <>
                            <ReferenceLine
                              yAxisId="expansao"
                              x={referenciasCurvasOtimas.umidadeReferencia}
                              stroke="#d32f2f"
                              strokeDasharray="6 4"
                            />
                            <ReferenceLine
                              yAxisId="expansao"
                              y={referenciasCurvasOtimas.expansaoPlot}
                              stroke="#d32f2f"
                              strokeDasharray="6 4"
                            />
                          </>
                        )}
                        <Line
                          yAxisId="densidade"
                          type="monotone"
                          dataKey="densidadeSuavizada"
                          name="Densidade seca"
                          stroke="#0f72cf"
                          strokeWidth={2}
                          dot={false}
                          activeDot={{ r: 6 }}
                          isAnimationActive={false}
                        />
                        <Line
                          yAxisId="densidade"
                          type="linear"
                          dataKey="densidadeSeca"
                          name="Densidade seca"
                          stroke="transparent"
                          strokeWidth={0}
                          dot={{ r: 4, stroke: "#0f72cf", fill: "#fff", strokeWidth: 2 }}
                          activeDot={{ r: 6 }}
                          legendType="none"
                          connectNulls={false}
                          isAnimationActive={false}
                        />
                        <Line
                          yAxisId="isc"
                          type="monotone"
                          dataKey="iscPlot"
                          name="I.S.C."
                          stroke="#7b1fa2"
                          strokeWidth={2}
                          dot={{ r: 4 }}
                          activeDot={{ r: 6 }}
                          connectNulls
                          isAnimationActive={false}
                        />
                        <Line
                          yAxisId="expansao"
                          type="monotone"
                          dataKey="expansaoPlot"
                          name="Expansão"
                          stroke="#ef6c00"
                          strokeWidth={2}
                          dot={{ r: 4 }}
                          activeDot={{ r: 6 }}
                          connectNulls
                          isAnimationActive={false}
                        />
                        <Legend />
                      </LineChart>
                    </ResponsiveContainer>
                  ) : (
                    graficoVazio("Informe umidade, densidade, CBR ou expansão para gerar o gráfico.")
                  )}
                </Paper>

                <Paper
                  sx={{
                    overflow: "auto",
                    border: "1px solid #d7dde8",
                    boxShadow: "none",
                    borderRadius: "8px",
                  }}
                >
                  <Table
                    size="small"
                    sx={{
                      minWidth: 900,
                      "& td, & th": {
                        borderColor: "#d7dde8",
                        fontSize: 12,
                        color: "#334155",
                      },
                    }}
                  >
                    <TableBody>
                      <TableRow>
                        <TableCell
                          colSpan={12}
                          sx={{ ...cellSx, fontWeight: 700, color: "#0f172a" }}
                        >
                          RESUMO
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        {[
                          ["DENS. MÁX.", "densidadeMaxima", "g/cm³"],
                          ["UMID. T.", "umidadeOtima", "%"],
                          ["I.S.C.", "isc", "%"],
                          ["EXP.", "expansao", "%"],
                          ["I.G.", "ig", ""],
                          ["T.R.B.", "trb", ""],
                        ].map(([titulo, campo, unidade]) => (
                          <React.Fragment key={campo}>
                            <TableCell
                              sx={{
                                ...cellSx,
                                fontWeight: 700,
                                color: "#0f172a",
                                backgroundColor: "#fbfdff",
                                width: 90,
                              }}
                            >
                              {titulo}
                            </TableCell>
                            <TableCell sx={{ ...cellSx, width: 120 }}>
                              <Stack direction="row" spacing={0.5} alignItems="center">
                                {campoTabela(
                                  ensaio.resultados?.[campo] || "",
                                  (valor) =>
                                    atualizar({
                                      resultados: {
                                        ...ensaio.resultados,
                                        [campo]: valor,
                                      },
                                      resultadosManuais: {
                                        ...(ensaio.resultadosManuais || {}),
                                        ...(campo === "densidadeMaxima" ||
                                        campo === "umidadeOtima"
                                          ? { [campo]: true }
                                          : {}),
                                      },
                                    }),
                                  {
                                    inputProps: {
                                      style: {
                                        textAlign: "center",
                                        fontSize: 12,
                                        padding: "5px 6px",
                                        height: 18,
                                      },
                                    },
                                  }
                                )}
                                {unidade && (
                                  <Typography variant="caption" sx={{ whiteSpace: "nowrap" }}>
                                    {unidade}
                                  </Typography>
                                )}
                              </Stack>
                            </TableCell>
                          </React.Fragment>
                        ))}
                      </TableRow>
                    </TableBody>
                  </Table>
                </Paper>
              </Stack>
            )}

           {tab === 1 && (
  <Stack spacing={3}>
    <Paper
  sx={{
    overflow: "auto",
    border: "1px solid #d7dde8",
    boxShadow: "none",
    borderRadius: "8px",
  }}
>
  <Table
    size="small"
    sx={{
      width: "100%",
      minWidth: 0,
      tableLayout: "fixed",
      "& td, & th": {
        borderColor: "#d7dde8",
        fontSize: 11,
        color: "#334155",
        textAlign: "center",
        px: "3px",
        py: "4px",
      },
      "& td:first-of-type": {
        fontWeight: 700,
        color: "#0f172a",
        backgroundColor: "#fbfdff",
      },
      "& .MuiTextField-root": {
        minWidth: 0,
      },
      "& .MuiOutlinedInput-root": {
        height: 28,
        minWidth: 0,
      },
      "& .MuiInputBase-input": {
        minWidth: 0,
        px: "3px",
        fontSize: 11,
      },
    }}
  >
        <TableBody>
          <TableRow>
            <TableCell
                colSpan={15}
                sx={{ ...cellSx, fontWeight: 700, color: "#0f172a" }}
              >
                ENSAIO DE EXPANSÃO
              </TableCell>
          </TableRow>

          <TableRow>
            {[0, 1, 2, 3, 4].map((index) => (
              <React.Fragment key={index}>
                <TableCell sx={{ fontWeight: 700 }}>CILINDRO</TableCell>
                <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
                  {expansaoComCilindrosCompactacao[index]?.cilindro || "-"}
                </TableCell>
              </React.Fragment>
            ))}
          </TableRow>

          <TableRow>
            {[0, 1, 2, 3, 4].map((index) => (
              <React.Fragment key={index}>
                <TableCell>DATA</TableCell>
                <TableCell>HORA</TableCell>
                <TableCell>LEITURA</TableCell>
              </React.Fragment>
            ))}
          </TableRow>

          <TableRow>
            {expansaoComCilindrosCompactacao.slice(0, 5).map((linha, index) => (
              <React.Fragment key={index}>
                <TableCell>
                  {temLeituraExpansao(linha.leituraInicial) ? campoTabela(linha.dataInicial, () => {}, { type: "date", disabled: true }) : "-"}
                </TableCell>

                <TableCell>
                  {temLeituraExpansao(linha.leituraInicial) ? campoTabela(linha.horaInicial, (valor) => {
                    const calculada = calcularLinhaExpansaoLocal(
                      { ...linha, horaInicial: valor },
                      ensaio.compactacao?.[index] || {}
                    );
                    atualizarLista("expansao", index, calculada);
                  }, { type: "time" }) : "-"}
                </TableCell>

                <TableCell>
                  {campoTabela(linha.leituraInicial, (valor) => {
                    const calculada = calcularLinhaExpansaoLocal(
                      { ...linha, leituraInicial: valor },
                      ensaio.compactacao?.[index] || {}
                    );
                    atualizarLista("expansao", index, calculada);
                  })}
                </TableCell>
              </React.Fragment>
            ))}
          </TableRow>

          {[0, 1, 2].map((leituraIndex) => (
            <TableRow key={leituraIndex}>
              {expansaoComCilindrosCompactacao.slice(0, 5).map((linha, index) => {
                const leitura = linha.leiturasDiarias?.[leituraIndex] || {};
                return (
                  <React.Fragment key={index}>
                    <TableCell>{temLeituraExpansao(leitura.leitura) ? campoTabela(leitura.data, () => {}, { type: "date", disabled: true }) : "-"}</TableCell>
                    <TableCell>{temLeituraExpansao(leitura.leitura) ? campoTabela(leitura.hora, (valor) => atualizarLeituraDiariaExpansao(index, leituraIndex, { hora: valor }), { type: "time" }) : "-"}</TableCell>
                    <TableCell>{campoTabela(leitura.leitura, (valor) => atualizarLeituraDiariaExpansao(index, leituraIndex, { leitura: valor }))}</TableCell>
                  </React.Fragment>
                );
              })}
            </TableRow>
          ))}

          <TableRow>
            {expansaoComCilindrosCompactacao.slice(0, 5).map((linha, index) => (
              <React.Fragment key={index}>
                <TableCell>
                  {temLeituraExpansao(linha.leituraFinal) ? campoTabela(linha.dataFinal, () => {}, { type: "date", disabled: true }) : "-"}
                </TableCell>

                <TableCell>
                  {temLeituraExpansao(linha.leituraFinal) ? campoTabela(linha.horaFinal, (valor) => {
                    const calculada = calcularLinhaExpansaoLocal(
                      { ...linha, horaFinal: valor },
                      ensaio.compactacao?.[index] || {}
                    );
                    atualizarLista("expansao", index, calculada);
                  }, { type: "time" }) : "-"}
                </TableCell>

                <TableCell>
                  {campoTabela(linha.leituraFinal, (valor) => {
                    const calculada = calcularLinhaExpansaoLocal(
                      { ...linha, leituraFinal: valor },
                      ensaio.compactacao?.[index] || {}
                    );
                    atualizarLista("expansao", index, calculada);
                  })}
                </TableCell>
              </React.Fragment>
            ))}
          </TableRow>

          <TableRow>
            {expansaoComCilindrosCompactacao.slice(0, 5).map((linha, index) => (
              <React.Fragment key={index}>
                <TableCell>DIFERENÇA</TableCell>
                <TableCell colSpan={2}>{linha.diferenca || "-"}</TableCell>
              </React.Fragment>
            ))}
          </TableRow>

          <TableRow>
            {expansaoComCilindrosCompactacao.slice(0, 5).map((linha, index) => (
              <React.Fragment key={index}>
                <TableCell>EXPANSÃO</TableCell>
                <TableCell>{linha.expansao || "-"}</TableCell>
                <TableCell>%</TableCell>
              </React.Fragment>
            ))}
          </TableRow>

          <TableRow>
            <TableCell
  colSpan={15}
  sx={{ ...cellSx, fontWeight: 700, color: "#0f172a" }}
>
  PENETRAÇÃO
</TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={15} sx={{ color: "#475569", textAlign: "left" }}>
              Correção DNIT 172/2016-ME: ao marcar o corpo de prova, o sistema
              estima automaticamente a distância c pela reta de maior inclinação.
              O valor em mm pode ser ajustado manualmente.
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={{ fontWeight: 700 }}>
              Tipo:
            </TableCell>
            <TableCell colSpan={3}>
              <TextField
                select
                value={ensaio.tipoMedicaoCbr || "anel"}
                onChange={(e) => atualizar({ tipoMedicaoCbr: e.target.value })}
                size="small"
                fullWidth
              >
                <MenuItem value="anel">Anel dinamométrico</MenuItem>
                <MenuItem value="celula">Célula de carga</MenuItem>
              </TextField>
            </TableCell>
            <TableCell sx={{ fontWeight: 700 }}>
              Const. Anel:
            </TableCell>
            <TableCell colSpan={3}>
              {campoTabela(ensaio.constanteAnelCbr || "", (valor) =>
                atualizar({ constanteAnelCbr: valor })
              )}
            </TableCell>
            {(ensaio.tipoMedicaoCbr || "anel") === "celula" ? (
              <>
                <TableCell sx={{ fontWeight: 700 }}>Área pistão:</TableCell>
                <TableCell colSpan={3}>
                  {campoTabela(ensaio.areaPistaoCbr || "19,35", (valor) =>
                    atualizar({ areaPistaoCbr: valor })
                  )}
                </TableCell>
                <TableCell colSpan={3}></TableCell>
              </>
            ) : (
              <TableCell colSpan={7}></TableCell>
            )}
          </TableRow>

          <TableRow>
            <TableCell rowSpan={4} sx={{ fontWeight: 700, width: 70 }}>
              CILINDRO Nº
            </TableCell>
            <TableCell colSpan={3} sx={{ width: 150, fontWeight: 700, whiteSpace: "normal", lineHeight: 1.15 }}>
              PENETRAÇÃO (mm)
            </TableCell>
            {penetracoesCBR.map((ponto) => (
              <TableCell key={ponto.mm}>{ponto.mm}</TableCell>
            ))}
          </TableRow>

          <TableRow>
            <TableCell colSpan={3} sx={{ width: 150, fontWeight: 700, whiteSpace: "normal", lineHeight: 1.15 }}>
              TEMPO (min)
            </TableCell>
            {penetracoesCBR.map((ponto) => (
              <TableCell key={ponto.mm}>{ponto.tempo}</TableCell>
            ))}
          </TableRow>

          <TableRow>
            <TableCell colSpan={3} sx={{ width: 150, fontWeight: 700 }}>LEITURA</TableCell>
            {penetracoesCBR.map((ponto) => (
              <TableCell key={ponto.mm}>-</TableCell>
            ))}
          </TableRow>

          <TableRow>
            <TableCell colSpan={3} sx={{ width: 150, fontWeight: 700, whiteSpace: "normal", lineHeight: 1.15 }}>
              PRESSÃO (kg/cm²)
            </TableCell>
            {penetracoesCBR.map((ponto) => (
              <TableCell key={ponto.mm}>-</TableCell>
            ))}
          </TableRow>

          {cbrComCilindrosCompactacao.slice(0, 5).map((linha, index) => (
            <React.Fragment key={index}>
              <TableRow>
                <TableCell rowSpan={4} sx={{ fontWeight: 700, width: 70 }}>
                  {linha.cilindro || "-"}
                </TableCell>

                <TableCell colSpan={3} sx={{ width: 150, fontWeight: 700 }}>LEITURA</TableCell>

                {penetracoesCBR.map((ponto, leituraIndex) => {
                  const leitura = linha.leituras?.[leituraIndex] || {};

                  return (
                    <TableCell key={ponto.mm}>
                      {campoTabela(leitura.leitura || "", (valor) => {
                        const leituras = [...(linha.leituras || [])];

                        leituras[leituraIndex] = {
                          ...leituras[leituraIndex],
                          mm: ponto.mm,
                          leitura: valor,
                        };

                        atualizarLista("cbr", index, {
                          cilindro: linha.cilindro,
                          leituras,
                        });
                      })}
                    </TableCell>
                  );
                })}
              </TableRow>

              <TableRow>
                <TableCell colSpan={3} sx={{ width: 150, fontWeight: 700, whiteSpace: "normal", lineHeight: 1.15 }}>
                  PRESSÃO (kg/cm²)
                </TableCell>

                {penetracoesCBR.map((ponto, leituraIndex) => {
                  const leitura = linha.leituras?.[leituraIndex] || {};

                  return (
                    <TableCell key={ponto.mm}>
                      {leitura.pressao || "-"}
                    </TableCell>
                  );
                })}
              </TableRow>

              <TableRow>
                <TableCell
                  colSpan={3}
                  sx={{
                    width: 150,
                    bgcolor: linha.aplicarCorrecao === true ? "#fff7ed" : undefined,
                  }}
                >
                  <Stack alignItems="center" justifyContent="center" spacing={0.5}>
                    <Typography variant="caption" fontWeight={700} color="error.main">
                      PRESSÃO CORRIGIDA
                    </Typography>
                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
                      <Checkbox
                        size="small"
                        checked={linha.aplicarCorrecao === true}
                        onChange={e =>
                          alternarCorrecaoCbr(index, linha, e.target.checked)
                        }
                      />
                      <TextField
                        size="small"
                        label="c (mm)"
                        value={linha.correcaoCbrMm || ""}
                        error={
                          linha.aplicarCorrecao === true &&
                          !(numeroDecimal(linha.correcaoCbrMm) > 0)
                        }
                        onChange={e =>
                          atualizarLista("cbr", index, {
                            cilindro: linha.cilindro,
                            correcaoCbrMm: e.target.value,
                          })
                        }
                        sx={{ width: 78 }}
                      />
                    </Stack>
                  </Stack>
                </TableCell>
                {penetracoesCBR.map((ponto, leituraIndex) => {
                  const leitura = linha.leituras?.[leituraIndex] || {};
                  return (
                    <TableCell
                      key={ponto.mm}
                      sx={{
                        bgcolor: linha.aplicarCorrecao === true ? "#fff7ed" : undefined,
                        color: linha.aplicarCorrecao === true ? "#c62828" : undefined,
                        fontWeight: linha.aplicarCorrecao === true ? 700 : 400,
                      }}
                    >
                      {leitura.correcao || "-"}
                    </TableCell>
                  );
                })}
              </TableRow>

              <TableRow>
                <TableCell colSpan={3} sx={{ width: 150, fontWeight: 700 }}>I.S.C.</TableCell>

                {penetracoesCBR.map((ponto) => (
                  <TableCell key={ponto.mm}>
                    {mesmoPontoPenetracao(ponto.mm, 2.54)
                      ? linha.isc254 || "-"
                      : mesmoPontoPenetracao(ponto.mm, 5.08)
                      ? linha.isc508 || "-"
                      : ""}
                  </TableCell>
                ))}
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>

      <Box
        sx={{
          p: 2,
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 2,
        }}
      >
        {cbrComCilindrosCompactacao
          .slice(0, 5)
          .filter(linha =>
            linha.leituras?.some(
              leitura => numeroDecimal(leitura.pressao) !== null
            )
          )
          .map((linha, index) => {
            const deslocamentoCorrecao = numeroDecimal(linha.correcaoCbrMm);
            const correcaoAtiva =
              linha.aplicarCorrecao === true &&
              deslocamentoCorrecao !== null &&
              deslocamentoCorrecao > 0 &&
              linha.leituras?.some(
                leitura => numeroDecimal(leitura.correcao) !== null
              );
            const dadosCurva = [
              { penetracao: 0, pressao: 0 },
              ...(linha.leituras || []).map(leitura => ({
                penetracao: numeroDecimal(leitura.mm),
                pressao: numeroDecimal(leitura.pressao),
              })),
            ].filter(
              ponto => ponto.penetracao !== null && ponto.pressao !== null
            );
            const modeloCorrecaoGrafico = correcaoAtiva
              ? criarModeloCorrecaoCbr(linha.leituras || [], deslocamentoCorrecao)
              : null;
            const leitura254 = linha.leituras?.find(leitura =>
              mesmoPontoPenetracao(leitura.mm, 2.54)
            );
            const leitura508 = linha.leituras?.find(leitura =>
              mesmoPontoPenetracao(leitura.mm, 5.08)
            );
            const guiasCorrecao = correcaoAtiva
              ? [
                  { nome: "P1", x: 2.54, y: numeroDecimal(leitura254?.pressao), cor: "#64748b" },
                  { nome: "P1'", x: 2.54 + deslocamentoCorrecao, y: numeroDecimal(leitura254?.correcao), cor: "#c62828" },
                  { nome: "P2", x: 5.08, y: numeroDecimal(leitura508?.pressao), cor: "#64748b" },
                  { nome: "P2'", x: 5.08 + deslocamentoCorrecao, y: numeroDecimal(leitura508?.correcao), cor: "#c62828" },
                ].filter(guia => guia.y !== null)
              : [];
            const dadosGrafico = gerarLinhaTendenciaVisualCbr(
              dadosCurva,
              100
            );

            return (
              <Paper key={linha.cilindro || index} variant="outlined" sx={{ p: 1 }}>
                <Typography fontWeight={700} textAlign="center" mb={1}>
                  Pressão x penetração - CP {linha.cilindro || index + 1}
                </Typography>
                <ResponsiveContainer width="100%" height={220}>
                  <LineChart data={dadosGrafico} margin={{ top: 10, right: 15, bottom: 25, left: 5 }}>
                    <CartesianGrid stroke="#94a3b8" strokeWidth={0.5} />
                    <XAxis
                      type="number"
                      dataKey="penetracao"
                      domain={[0, "dataMax"]}
                      label={{ value: "Penetração (mm)", position: "insideBottom", offset: -15 }}
                    />
                    <YAxis label={{ value: "Pressão (kg/cm²)", angle: -90, position: "insideLeft" }} />
                    <ChartTooltip />
                    {correcaoAtiva && (
                      <ReferenceLine
                        x={deslocamentoCorrecao}
                        stroke="#d97706"
                        strokeWidth={0.8}
                        strokeDasharray="4 3"
                        label={{ value: "c", position: "insideBottomRight", fill: "#92400e" }}
                      />
                    )}
                    {modeloCorrecaoGrafico && (
                      <>
                        <ReferenceLine
                          segment={[
                            { x: modeloCorrecaoGrafico.deslocamento, y: 0 },
                            {
                              x: modeloCorrecaoGrafico.pontoInflexao.penetracao,
                              y: modeloCorrecaoGrafico.pontoInflexao.pressao,
                            },
                          ]}
                          stroke="#d97706"
                          strokeWidth={1.2}
                        />
                        <ReferenceDot
                          x={modeloCorrecaoGrafico.pontoInflexao.penetracao}
                          y={modeloCorrecaoGrafico.pontoInflexao.pressao}
                          r={3}
                          fill="#d97706"
                          stroke="#ffffff"
                          strokeWidth={0.8}
                          label={{
                            value: "Inflexão",
                            position: "top",
                            fill: "#92400e",
                            fontSize: 9,
                          }}
                          ifOverflow="extendDomain"
                        />
                      </>
                    )}
                    {guiasCorrecao.map(guia => (
                      <React.Fragment key={guia.nome}>
                        <ReferenceLine
                          segment={[{ x: guia.x, y: 0 }, { x: guia.x, y: guia.y }]}
                          stroke={guia.cor}
                          strokeWidth={0.8}
                          strokeDasharray="4 3"
                        />
                        <ReferenceLine
                          segment={[{ x: 0, y: guia.y }, { x: guia.x, y: guia.y }]}
                          stroke={guia.cor}
                          strokeWidth={0.8}
                          strokeDasharray="4 3"
                          label={{ value: guia.nome, position: "right", fill: guia.cor }}
                        />
                      </React.Fragment>
                    ))}
                    <Line
                      type="linear"
                      dataKey="pressao"
                      name="Original"
                      stroke="#111827"
                      strokeWidth={1}
                      dot={false}
                      connectNulls
                      isAnimationActive={false}
                    />
                    {dadosCurva.map((ponto, pontoIndex) => (
                      <ReferenceDot
                        key={`leitura-${pontoIndex}`}
                        x={ponto.penetracao}
                        y={ponto.pressao}
                        r={2}
                        fill="#111827"
                        stroke="none"
                        ifOverflow="extendDomain"
                      />
                    ))}
                  </LineChart>
                </ResponsiveContainer>
                {correcaoAtiva && (
                  <Typography variant="caption" color="#a65f5f" display="block" textAlign="center">
                    Correção DNIT: tangente no ponto de inflexão e origem deslocada em c.
                  </Typography>
                )}
              </Paper>
            );
          })}
      </Box>
    </Paper>
  </Stack>
)}

            {tab === 2 && (
              <TabelaGranulometria
                granulometria={ensaio.granulometria}
                faixasDnit={faixasDnit}
                onCapsula={alterarCapsulaHigroscopica}
                onUmidade={atualizarUmidadeHigroscopica}
                onAmostra={(campo, valor) =>
                  atualizarGranulometria("amostraSeca", {
                    ...(ensaio.granulometria?.amostraSeca || {}),
                    [campo]: valor,
                  })
                }
                onPeneiramento={(index, campo, valor) => {
                  const lista = [...(ensaio.granulometria?.peneiramento || [])];
                  lista[index] = { ...lista[index], [campo]: valor };
                  atualizarGranulometria("peneiramento", lista);
                }}
                onFaixaDnit={(letra) => {
                  const lista = (ensaio.granulometria?.peneiramento || []).map((linha) => {
                    const nome = String(linha.nome || "").replace(/^N[º°]\s*/i, "");
                    const faixa = faixasDnit.find((item) => item.peneira === linha.nome || item.peneira === nome);
                    const valores = faixa?.[letra] || {};

                    return {
                      ...linha,
                      faixaDnitMin: valores.min || "",
                      faixaDnitMax: valores.max || "",
                      faixaDnit: [valores.min, valores.max].filter(Boolean).join(" - "),
                    };
                  });

                  iniciarEdicao();
                  atualizar({
                    granulometria: {
                      ...ensaio.granulometria,
                      faixaDnitSelecionada: letra,
                      peneiramento: lista,
                    },
                  });
                }}
                onClassificacao={(campo, valor) => atualizarGranulometria(campo, valor)}
              />
            )}

            {false && tab === 2 && (
              <Stack spacing={3}>
                <Typography fontWeight={700}>Umidade Higroscópica</Typography>

                <Paper
                  sx={{
                    overflow: "auto",
                    border: "1px solid #d7dde8",
                    boxShadow: "none",
                  }}
                >
                  <Table size="small" sx={{ minWidth: 720 }}>
                    <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                      <TableRow>
                        {[
                          "Cápsula",
                          "Cápsula + solo + água",
                          "Cápsula + solo",
                          "Água",
                          "Cápsula",
                          "Solo",
                          "% Umidade",
                        ].map((titulo) => (
                          <TableCell key={titulo} sx={cellSx}>
                            {titulo}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {garantirDuasUmidadesHigroscopicas(
                        ensaio.granulometria?.umidadeHigroscopica || []
                      ).map((linha, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            {campoTabela(
                              linha.capsulaNumero ?? linha.capsula ?? "",
                              (valor) => alterarCapsulaHigroscopica(index, valor),
                              {
                                inputProps: {
                                  maxLength: 3,
                                  style: { textAlign: "center", fontSize: 12 },
                                },
                              }
                            )}
                          </TableCell>

                          {["capsulaSoloAgua", "capsulaSolo"].map((campo) => (
                            <TableCell key={campo}>
                              {campoTabela(linha[campo], (valor) =>
                                atualizarUmidadeHigroscopica(index, {
                                  [campo]: valor,
                                })
                              )}
                            </TableCell>
                          ))}

                          {["agua", "pesoCapsula", "solo", "umidade"].map((campo) => (
                            <TableCell key={campo} sx={cellSx}>
                              {linha[campo] || "-"}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>

                <Typography fontWeight={700}>Peneiramento</Typography>

                <Paper
                  sx={{
                    overflow: "auto",
                    border: "1px solid #d7dde8",
                    boxShadow: "none",
                  }}
                >
                  <Table size="small" sx={{ minWidth: 860 }}>
                    <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                      <TableRow>
                        {[
                          "Peneira",
                          "mm",
                          "Peso retido",
                          "% retido",
                          "% acumulado",
                          "% que passa",
                          "Faixa DNIT",
                        ].map((titulo) => (
                          <TableCell key={titulo} sx={cellSx}>
                            {titulo}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {(ensaio.granulometria.peneiramento || []).map(
                        (linha, index) => (
                          <TableRow key={`${linha.nome}-${index}`}>
                            <TableCell>{linha.nome}</TableCell>
                            <TableCell sx={cellSx}>{linha.abertura}</TableCell>

                            {[
                              "pesoRetido",
                              "percentualRetido",
                              "acumulado",
                              "percentualPassante",
                              "faixaDnit",
                            ].map((campo) => (
                              <TableCell key={campo}>
                                {campo === "pesoRetido" || campo === "faixaDnit"
                      ? campoTabela(linha[campo], (valor) => {
                          const lista = [
                            ...ensaio.granulometria.peneiramento,
                          ];

                          lista[index] = {
                            ...lista[index],
                            [campo]: valor,
                          };

                          atualizarGranulometria("peneiramento", lista);
                        })
                      : valorCalculado(linha[campo] || "-")}

                              </TableCell>
                            ))}
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </Paper>
              </Stack>
            )}

            {tab === 3 && (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", lg: "2fr 1fr" },
      gap: 1.5,
      alignItems: "start",
    }}
  >
    <Stack spacing={1.5}>
      <TabelaLimites
        titulo="LIMITE DE LIQUIDEZ"
        linhas={ensaio.limites.liquidez || []}
        capsulas={capsulas}
        tipoCapsula="limite_liquidez"
        comGolpes
        onChange={(linhas) => atualizarLimites("liquidez", linhas)}
      />

      <TabelaLimites
        titulo="LIMITE DE PLASTICIDADE"
        linhas={ensaio.limites.plasticidade || []}
        capsulas={capsulas}
        tipoCapsula="limite_plasticidade"
        tipoPesoPlasticidade={ensaio.limites.tipoPesoPlasticidade || "tampa"}
        onTipoPesoPlasticidadeChange={atualizarTipoPesoPlasticidade}
        onChange={(linhas) => atualizarLimites("plasticidade", linhas)}
      />

      <Paper variant="outlined" sx={{ p: 1.5 }}>
        <Typography sx={{ fontWeight: 700, fontSize: 13, mb: 1 }}>
          Escala do gráfico de limite de liquidez
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(4, 1fr)" },
            gap: 1,
          }}
        >
          {[
            ["golpesMin", "Golpes mínimo"],
            ["golpesMax", "Golpes máximo"],
            ["umidadeMin", "Umidade mínima (%)"],
            ["umidadeMax", "Umidade máxima (%)"],
          ].map(([campo, label]) => (
            <TextField
              key={campo}
              label={label}
              value={ensaio.limites.escalaGraficoLiquidez?.[campo] ?? ""}
              onChange={(event) =>
                atualizarLimites("escalaGraficoLiquidez", {
                  ...(ensaio.limites.escalaGraficoLiquidez || {}),
                  [campo]: event.target.value,
                })
              }
              size="small"
              inputProps={{ inputMode: "decimal" }}
            />
          ))}
        </Box>
      </Paper>

      <GraficoLimiteLiquidez
        liquidez={ensaio.limites.liquidez || []}
        escala={ensaio.limites.escalaGraficoLiquidez || {}}
      />
    </Stack>

    <Stack spacing={1.5}>
      <QuadroResultadosLimites resultados={ensaio.limites.resultados || {}} />

      <QuadroEntradaLimites
        titulo="EQUIVALENTE DE AREIA"
        grupo="equivalenteAreia"
        dados={ensaio.limites.equivalenteAreia || {}}
        campos={[
          ["topoAreia", "Topo da Areia"],
          ["topoArgila", "Topo da Argila"],
          ["ea", "E.A."],
          ["media", "Média"],
        ]}
        onChange={atualizarGrupoLimites}
      />

      <QuadroEntradaLimites
        titulo="MASSA ESPECÍFICA REAL"
        grupo="massaEspecificaReal"
        dados={ensaio.limites.massaEspecificaReal || {}}
        campos={[
          ["temperatura", "Temperatura", "°C"],
          ["picnometroNumero", "Picnômetro", "Nº"],
          ["picnometro", "Picnômetro", "g"],
          ["picnometroSolo", "Picnômetro + solo", "g"],
          ["picSoloAgua", "Pic. + solo + água", "g"],
          ["picnometroAgua", "Picnômetro + água", "g"],
          ["aguaDeslocada", "Água deslocada", "g"],
          ["massaEspecificaReal", "Massa Específica Real"],
          ["media", "Média", "g/m³"],
        ]}
        onChange={atualizarGrupoLimites}
      />

      <QuadroEntradaLimites
        titulo="DENSIDADE SOLTA"
        grupo="densidadeSolta"
        dados={ensaio.limites.densidadeSolta || {}}
        campos={[
          ["taraRecipiente", "Tara do Recipiente"],
          ["volumeRecipiente", "Vol. do Recipiente"],
          ["soloRecipiente", "Solo + Recipiente"],
          ["solo", "Solo"],
          ["densidadeSolta", "Densidade Solta"],
          ["media", "Média"],
          ["empolamentoCamada", "Empolamento da Camada"],
        ]}
        onChange={atualizarGrupoLimites}
      />
    </Stack>
  </Box>
)}

            {tab === 4 && (
              <QuadroSubstituicaoSolo
                dados={ensaio.substituicaoSolo || criarSubstituicaoSolo()}
                onChange={atualizarSubstituicaoSolo}
              />
            )}

            {false && (
              <Stack spacing={3}>
                <Paper
                  sx={{
                    p: 2,
                    border: "1px solid #d7dde8",
                    boxShadow: "none",
                  }}
                >
                  <Typography fontWeight={700} mb={1}>
                    Curva de Compactação
                  </Typography>

                  {dadosCompactacao.length ? (
                    <ResponsiveContainer width="100%" height={330}>
                      <LineChart data={dadosCompactacao}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="umidade" />
                        <YAxis yAxisId="seca" />
                        <YAxis yAxisId="umida" orientation="right" />
                        <ChartTooltip />
                        <Legend />
                        {resultadoGraficoOtimo.umidadeOtima !== null && (
                          <ReferenceLine
                            x={resultadoGraficoOtimo.umidadeOtima}
                            stroke="#d32f2f"
                            strokeDasharray="6 4"
                            ifOverflow="extendDomain"
                          />
                        )}
                        {resultadoGraficoOtimo.densidadeMaxima !== null && (
                          <ReferenceLine
                            yAxisId="seca"
                            y={resultadoGraficoOtimo.densidadeMaxima}
                            stroke="#d32f2f"
                            strokeDasharray="6 4"
                            ifOverflow="extendDomain"
                          />
                        )}
                        <Line
                          yAxisId="seca"
                          type="monotone"
                          dataKey="densidadeSeca"
                          name="Densidade seca"
                          stroke="#0f72cf"
                          strokeWidth={2}
                          dot
                        />
                        <Line
                          yAxisId="umida"
                          type="monotone"
                          dataKey="densidadeUmida"
                          name="Densidade úmida"
                          stroke="#2e7d32"
                          strokeWidth={2}
                          dot
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  ) : (
                    graficoVazio("Informe os pontos da compactação.")
                  )}
                </Paper>

                <Stack direction={{ xs: "column", lg: "row" }} spacing={2}>
                  <GraficoSimples
                    titulo="CBR / I.S.C."
                    data={dadosCbr}
                    dataKey="isc"
                    name="I.S.C."
                    stroke="#9c27b0"
                  />

                  <GraficoSimples
                    titulo="Expansão"
                    data={dadosExpansao}
                    dataKey="expansao"
                    name="Expansão (%)"
                    stroke="#ef6c00"
                  />
                </Stack>
              </Stack>
            )}
          </Box>
        </Paper>
      </Box>
      <Dialog
        open={Boolean(confirmacaoUmidadePonto)}
        onClose={() => setConfirmacaoUmidadePonto(null)}
      >
        <DialogTitle>Substituir umidade higroscópica?</DialogTitle>
        <DialogContent>
          <Typography>
            Já existem dados de umidade higroscópica lançados. Ao informar a umidade de cada ponto, esses dados serão apagados.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button data-confirmacao-cancelamento="propria" onClick={() => setConfirmacaoUmidadePonto(null)}>Cancelar</Button>
          <Button
            variant="contained"
            onClick={() => {
              const atualizacao = confirmacaoUmidadePonto;
              setConfirmacaoUmidadePonto(null);
              atualizarUmidadePontoCompactacao(
                atualizacao.index,
                atualizacao.parcial,
                true
              );
            }}
          >
            Confirmar e apagar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function GraficoGranulometria({ peneiramento = [] }) {
  const peneirasGrafico = ['2"', '1"', '3/8"', "4", "10", "40", "200"];
  const linhas = [...peneiramento]
    .filter((item) => peneirasGrafico.includes(String(item.nome || "").replace(/^N[º°]\s*/i, "")))
    .filter((item) => numero(item.abertura) !== null)
    .sort((a, b) => numero(a.abertura) - numero(b.abertura));
  const width = 900;
  const height = 360;
  const margem = { left: 55, right: 20, top: 35, bottom: 48 };
  const plotW = width - margem.left - margem.right;
  const plotH = height - margem.top - margem.bottom;
  const logs = linhas.map((item) => Math.log10(numero(item.abertura)));
  const minLog = Math.min(...logs);
  const maxLog = Math.max(...logs);
  const sx = (abertura) => margem.left + ((Math.log10(numero(abertura)) - minLog) / (maxLog - minLog || 1)) * plotW;
  const sy = (valor) => margem.top + ((100 - Number(valor || 0)) / 100) * plotH;
  const path = (campo) =>
    linhas
      .map((item) => ({ x: sx(item.abertura), y: sy(numero(item[campo])), v: numero(item[campo]) }))
      .filter((p) => p.v !== null)
      .map((p, index) => `${index === 0 ? "M" : "L"} ${p.x} ${p.y}`)
      .join(" ");
  const pontos = (campo) =>
    linhas
      .map((item) => ({ x: sx(item.abertura), y: sy(numero(item[campo])), v: numero(item[campo]) }))
      .filter((p) => p.v !== null);
  const temFaixa = linhas.some((item) => numero(item.faixaDnitMin) !== null || numero(item.faixaDnitMax) !== null);

  return (
    <Paper sx={{ mt: 2, p: 2, overflow: "auto", border: "1px solid #d7dde8", boxShadow: "none" }}>
      <svg viewBox={`0 0 ${width} ${height}`} style={{ width: "100%", minWidth: 760, display: "block" }}>
        <text x={width / 2} y="18" textAnchor="middle" fontSize="12" fontWeight="700" fill="blue">PENEIRAS</text>
        <rect x={margem.left} y={margem.top} width={plotW} height={plotH} fill="#fff" stroke="#000" />
        {Array.from({ length: 11 }, (_, i) => {
          const y = margem.top + (i / 10) * plotH;
          const valor = 100 - i * 10;
          return <React.Fragment key={i}><line x1={margem.left} y1={y} x2={width - margem.right} y2={y} stroke="#000" strokeWidth="0.6" /><text x={margem.left - 10} y={y + 3} textAnchor="end" fontSize="10">{valor}</text></React.Fragment>;
        })}
        {linhas.map((item) => {
          const x = sx(item.abertura);
          return <React.Fragment key={item.nome || item.abertura}><line x1={x} y1={margem.top} x2={x} y2={height - margem.bottom} stroke="#000" strokeWidth="0.6" /><text x={x} y="30" textAnchor="middle" fontSize="8">{item.nome}</text><text x={x} y={height - 28} textAnchor="middle" fontSize="9">{item.abertura}</text></React.Fragment>;
        })}
        {temFaixa && <path d={path("faixaDnitMin")} fill="none" stroke="#000" strokeWidth="1" />}
        {temFaixa && <path d={path("faixaDnitMax")} fill="none" stroke="#000" strokeWidth="1" />}
        <path d={path("percentualPassante")} fill="none" stroke="red" strokeWidth="2" strokeDasharray="7 5" />
        {temFaixa &&
          pontos("faixaDnitMin").map((ponto, index) => (
            <circle key={`faixa-min-${index}`} cx={ponto.x} cy={ponto.y} r="3" fill="#000" />
          ))}
        {temFaixa &&
          pontos("faixaDnitMax").map((ponto, index) => (
            <circle key={`faixa-max-${index}`} cx={ponto.x} cy={ponto.y} r="3" fill="#000" />
          ))}
        {pontos("percentualPassante").map((ponto, index) => (
          <circle key={`passante-${index}`} cx={ponto.x} cy={ponto.y} r="3.5" fill="red" stroke="#fff" strokeWidth="1" />
        ))}
        <text x="18" y={height / 2} textAnchor="middle" fontSize="11" fill="blue" transform={`rotate(-90 18 ${height / 2})`}>% QUE PASSA</text>
        <text x={width / 2} y={height - 8} textAnchor="middle" fontSize="11" fill="blue">ABERTURA(mm)</text>
      </svg>
    </Paper>
  );
}

function TabelaGranulometria({
  granulometria = {},
  faixasDnit = [],
  onCapsula,
  onUmidade,
  onAmostra,
  onPeneiramento,
  onFaixaDnit,
  onClassificacao,
}) {
  const umidades = garantirDuasUmidadesHigroscopicas(
    granulometria.umidadeHigroscopica || []
  );
  const amostra = granulometria.amostraSeca || {};
  const peneiras = granulometria.peneiramento || [];

  const valorCalculado = (valor) => (
    <Box
      sx={{
        width: "100%",
        minHeight: 30,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 12,
        color: "#0f172a",
      }}
    >
      {valor || ""}
    </Box>
  );

  const campoNumerico = (valor, onChange, props = {}) =>
    campoTabela(valor, onChange, {
      ...props,
      inputProps: {
        ...props.inputProps,
        style: {
          textAlign: "center",
          fontSize: 12,
          padding: "5px 6px",
          height: 18,
          ...(props.inputProps?.style || {}),
        },
      },
    });

  const linhasEsquerda = [
    { tipo: "titulo", label: "UMIDADE HIGROSCÓPICA" },
    { label: "CÁPSULA Nº", valores: ["capsulaNumero", "capsula"], capsula: true },
    { label: "CÁPSULA + SOLO + ÁGUA", campo: "capsulaSoloAgua" },
    { label: "CÁPSULA + SOLO", campo: "capsulaSolo" },
    { label: "ÁGUA", campo: "agua", calculado: true },
    { label: "CÁPSULA", campo: "pesoCapsula", calculado: true },
    { label: "SOLO", campo: "solo", calculado: true },
    { label: "% UMIDADE", campo: "umidade", calculado: true },
    { label: "UMIDADE MÉDIA", valorUnico: granulometria.umidadeMedia || "" },
    { tipo: "titulo", label: "AMOSTRA TOTAL SECA" },
    { label: "Amostra Total Úmida (g)", amostraCampo: "amostraTotalUmida" },
    {
  label: "Solo Seco retido pen. Nº 10",
  valorUnico: granulometria.soloSecoRetidoPeneira10 || "",
},
    {
  label: "Solo Úmido pass. na peneira Nº 10",
  valorUnico: granulometria.soloUmidoPassante10 || "",
},
    {
  label: "Solo seco pass. na peneira Nº 10",
  valorUnico: granulometria.soloSecoPassante10 || "",
},
    {
  label: "Amostra Total Seca",
  valorUnico: granulometria.amostraTotalSeca || "",
},
    { label: "Amostra menor nº 10 Úmida", amostraCampo: "amostraMenor10Umida" },
    {
  label: "Amostra menor nº 10 Seca",
  valorUnico: granulometria.amostraMenor10Seca || "",
},
    { label: 'CLASSIFICAÇÃO "IG"', classificacao: "classificacaoIg" },
    { label: 'CLASSIFICAÇÃO "TRB"', classificacao: "classificacaoTrb" },
    { label: 'CLASSIFICAÇÃO "SUCS"', classificacao: "classificacaoSucs" },
  ];

  const camposPeneiramento = [
    { campo: "pesoRetido", editavel: true },
    { campo: "percentualRetido", editavel: false },
    { campo: "acumulado", editavel: false },
    { campo: "percentualPassante", editavel: false },
    { campo: "faixaDnitMin", editavel: false },
    { campo: "faixaDnitMax", editavel: false },
  ];

  const totalLinhas = Math.max(linhasEsquerda.length, peneiras.length);

  function renderEsquerda(linha) {
    if (!linha) return [<TableCell key="vazio" colSpan={3} sx={cellSx} />];

    if (linha.tipo === "titulo") {
      return [
        <TableCell
          key="titulo"
          colSpan={3}
          sx={{ ...cellSx, fontWeight: 800, color: "#000" }}
        >
          {linha.label}
        </TableCell>,
      ];
    }

    if (linha.valorUnico !== undefined) {
      return [
        <TableCell key="label" sx={{ ...cellSx, textAlign: "left", fontWeight: 700 }}>
          {linha.label}
        </TableCell>,
        <TableCell key="valor" colSpan={2} sx={cellSx}>
          {valorCalculado(linha.valorUnico || "-")}
        </TableCell>,
      ];
    }

    if (linha.amostraCampo) {
      return [
        <TableCell key="label" sx={{ ...cellSx, textAlign: "left" }}>
          {linha.label}
        </TableCell>,
        <TableCell key="valor" colSpan={2} sx={cellSx}>
          {campoNumerico(amostra[linha.amostraCampo], (valor) =>
            onAmostra(linha.amostraCampo, valor)
          )}
        </TableCell>,
      ];
    }

 if (linha.classificacao) {
  return [
    <TableCell
      key="label"
      sx={{ ...cellSx, textAlign: "left" }}
    >
      {linha.label}
    </TableCell>,

    <TableCell
      key="valor"
      colSpan={2}
      sx={{
        ...cellSx,
        fontWeight: 700,
        fontSize: 13,
        color: "#000",
        backgroundColor: "#fff",
      }}
    >
      {granulometria[linha.classificacao] || ""}
    </TableCell>,
  ];
}

    return [
      <TableCell key="label" sx={{ ...cellSx, textAlign: "left" }}>
        {linha.label}
      </TableCell>,

      ...umidades.map((item, index) => {
        const valor = linha.capsula
          ? item.capsulaNumero ?? item.capsula ?? ""
          : item[linha.campo] || "";

        return (
          <TableCell key={index} sx={cellSx}>
            {linha.capsula
              ? campoNumerico(valor, (novoValor) => onCapsula(index, novoValor), {
                  inputProps: { maxLength: 3 },
                })
              : linha.calculado
              ? valorCalculado(valor || "-")
              : campoNumerico(valor, (novoValor) =>
                  onUmidade(index, { [linha.campo]: novoValor })
                )}
          </TableCell>
        );
      }),
    ];
  }

  return (
    <>
    <Paper
      sx={{
        overflow: "auto",
        border: "1px solid #d7dde8",
        boxShadow: "none",
      }}
    >
      <Table
        size="small"
        sx={{
          width: "100%",
          minWidth: 0,
          tableLayout: "fixed",
          "& td, & th": {
            textAlign: "center",
            verticalAlign: "middle",
            fontSize: 11,
            px: "3px",
            py: "4px",
          },
          "& .MuiTextField-root": {
            minWidth: 0,
          },
          "& .MuiOutlinedInput-root": {
            minWidth: 0,
          },
          "& .MuiInputBase-input": {
            minWidth: 0,
            px: "3px",
            fontSize: 11,
          },
        }}
      >
        <colgroup>
          <col style={{ width: 150 }} />
          <col style={{ width: 100 }} />
          <col style={{ width: 100 }} />
          <col style={{ width: 42 }} />
          <col style={{ width: 42 }} />
          <col style={{ width: 120 }} />
          <col style={{ width: 82 }} />
          <col style={{ width: 82 }} />
          <col style={{ width: 120 }} />
          <col style={{ width: 60 }} />
          <col style={{ width: 60 }} />
        </colgroup>
        <TableHead sx={{ backgroundColor: "#f8fafc" }}>
          <TableRow>
            <TableCell colSpan={11} sx={{ ...cellSx, textAlign: "left" }}>
              <TextField
                select
                size="small"
                label="Faixa DNIT"
                value={granulometria.faixaDnitSelecionada || ""}
                onChange={(e) => onFaixaDnit(e.target.value)}
                sx={{ width: 180 }}
              >
                <MenuItem value="">Sem faixa</MenuItem>
                {["A", "B", "C", "D", "E", "F"].map((letra) => (
                  <MenuItem key={letra} value={letra}>
                    Faixa {letra}
                  </MenuItem>
                ))}
              </TextField>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={3} sx={{ ...cellSx, fontWeight: 800 }}>
              UMIDADE HIGROSCÓPICA / AMOSTRA TOTAL SECA
            </TableCell>

            <TableCell colSpan={2} sx={{ ...cellSx, fontWeight: 800 }}>
              PENEIRAS
            </TableCell>

            <TableCell colSpan={4} sx={{ ...cellSx, fontWeight: 800 }}>
              PENEIRAMENTO
            </TableCell>
            <TableCell colSpan={2} sx={{ ...cellSx, fontWeight: 800 }}>
              "FAIXA DNIT"
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cellSx}></TableCell>
            <TableCell sx={cellSx}>1</TableCell>
            <TableCell sx={cellSx}>2</TableCell>
            <TableCell sx={cellSx}>Nº</TableCell>
            <TableCell sx={cellSx}>mm</TableCell>
            <TableCell sx={cellSx}>Peso (g)</TableCell>
            <TableCell sx={cellSx}>% Amost. Total</TableCell>
            <TableCell sx={cellSx}>% Acumulado</TableCell>
            <TableCell sx={cellSx}>% Que Passa da Amostra Total</TableCell>
            <TableCell sx={cellSx}>Min</TableCell>
            <TableCell sx={cellSx}>Max</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {Array.from({ length: totalLinhas }).map((_, index) => {
            const peneira = peneiras[index] || {};

            return (
              <TableRow key={index}>
                {renderEsquerda(linhasEsquerda[index])}

                <TableCell sx={cellSx}>{peneira.nome || ""}</TableCell>
                <TableCell sx={cellSx}>{peneira.abertura || ""}</TableCell>

                {camposPeneiramento.map(({ campo, editavel }) => (
  <TableCell key={campo} sx={cellSx}>
    {editavel
      ? campoNumerico(
          peneira[campo] || "",
          (valor) => onPeneiramento(index, campo, valor),
          {
            inputProps: {
              "data-enter-row": index,
              "data-enter-col": campo,
            },
          }
        )
      : valorCalculado(peneira[campo] || "-")}
  </TableCell>
))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
    <GraficoGranulometria peneiramento={peneiras} />
    </>
  );
}

function QuadroSubstituicaoSolo({ dados, onChange }) {
  const calculos = calcularSubstituicaoSolo(dados);
  const campoPeso = (campo, label) => (
    <TextField
      label={label}
      value={dados[campo] || ""}
      onChange={(event) => onChange(campo, event.target.value)}
      size="small"
      fullWidth
      inputProps={{ inputMode: "decimal" }}
      InputProps={{ endAdornment: <Typography color="text.secondary">g</Typography> }}
    />
  );
  const linhaResultado = (
    descricao,
    percentual,
    peso,
    casasPercentual = 2,
    casasPeso = casasPercentual
  ) => (
    <TableRow>
      <TableCell>{descricao}</TableCell>
      <TableCell sx={cellSx}>{formatarCalculo(percentual, casasPercentual)}%</TableCell>
      <TableCell sx={{ ...cellSx, fontWeight: 700 }}>{formatarCalculo(peso, casasPeso)} g</TableCell>
    </TableRow>
  );

  return (
    <Stack spacing={2}>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="h6" fontWeight={700} mb={0.5}>
          Composição da amostra original
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Informe em gramas os pesos obtidos após o peneiramento nas peneiras 3/4&quot; (19,0 mm) e nº 4 (4,75 mm).
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
            gap: 1.5,
          }}
        >
          {campoPeso("pesoRetidoTresQuartos", "Retido na peneira 3/4\" (19,0 mm)")}
          {campoPeso("pesoRetidoNumero4", "Retido na peneira nº 4 (4,75 mm)")}
          {campoPeso("pesoPassanteNumero4", "Passante na peneira nº 4 (4,75 mm)")}
        </Box>

        <Box sx={{ overflowX: "auto", mt: 2 }}>
          <Table size="small" sx={{ minWidth: 620 }}>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 700 }}>Fração</TableCell>
                <TableCell sx={{ ...cellSx, fontWeight: 700 }}>Percentual</TableCell>
                <TableCell sx={{ ...cellSx, fontWeight: 700 }}>Peso original</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {linhaResultado("Retido na peneira 3/4\" (19,0 mm)", calculos.percentualTresQuartos, numeroDecimal(dados.pesoRetidoTresQuartos) || 0, 1, 0)}
              {linhaResultado("Retido na peneira nº 4 (4,75 mm)", calculos.percentualNumero4, numeroDecimal(dados.pesoRetidoNumero4) || 0, 1, 0)}
              {linhaResultado("Passante na peneira nº 4 (4,75 mm)", calculos.percentualPassanteNumero4, numeroDecimal(dados.pesoPassanteNumero4) || 0, 1, 0)}
              <TableRow sx={{ backgroundColor: "#f8fafc" }}>
                <TableCell sx={{ fontWeight: 800 }}>Amostra total</TableCell>
                <TableCell sx={{ ...cellSx, fontWeight: 800 }}>
                  {calculos.amostraTotal > 0 ? "100,0%" : "0,0%"}
                </TableCell>
                <TableCell sx={{ ...cellSx, fontWeight: 800 }}>
                  {formatarCalculo(calculos.amostraTotal, 0)} g
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Paper>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", lg: "repeat(2, 1fr)" },
          gap: 2,
        }}
      >
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="h6" fontWeight={700} mb={2}>
            Amostra para compactação
          </Typography>
          {campoPeso("pesoAmostraCompactacao", "Peso da nova amostra")}
          <Table size="small" sx={{ mt: 2 }}>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 700 }}>Material</TableCell>
                <TableCell sx={{ ...cellSx, fontWeight: 700 }}>%</TableCell>
                <TableCell sx={{ ...cellSx, fontWeight: 700 }}>Peso</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {linhaResultado("Retidos 3/4\" (19,0 mm) + nº 4 (4,75 mm)", calculos.percentualRetidoTotal, calculos.compactacaoRetidos, 1, 0)}
              {linhaResultado("Passante nº 4 (4,75 mm)", calculos.percentualPassanteNumero4, calculos.compactacaoPassante, 1, 0)}
              <TableRow sx={{ backgroundColor: "#f8fafc" }}>
                <TableCell sx={{ fontWeight: 800 }}>Total preparado</TableCell>
                <TableCell sx={{ ...cellSx, fontWeight: 800 }}>
                  {calculos.amostraTotal > 0 ? "100,0%" : "0,0%"}
                </TableCell>
                <TableCell sx={{ ...cellSx, fontWeight: 800 }}>
                  {formatarCalculo(calculos.compactacaoRetidos + calculos.compactacaoPassante, 0)} g
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>

        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="h6" fontWeight={700} mb={2}>
            Amostra para granulometria
          </Typography>
          {campoPeso("pesoAmostraGranulometria", "Peso da nova amostra")}
          <Table size="small" sx={{ mt: 2 }}>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 700 }}>Material</TableCell>
                <TableCell sx={{ ...cellSx, fontWeight: 700 }}>%</TableCell>
                <TableCell sx={{ ...cellSx, fontWeight: 700 }}>Peso</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {linhaResultado("Retido na peneira 3/4\" (19,0 mm)", calculos.percentualTresQuartos, calculos.granulometriaTresQuartos, 1)}
              {linhaResultado("Retido na peneira nº 4 (4,75 mm)", calculos.percentualNumero4, calculos.granulometriaNumero4, 1)}
              {linhaResultado("Passante na peneira nº 4 (4,75 mm)", calculos.percentualPassanteNumero4, calculos.granulometriaPassante, 1)}
              <TableRow sx={{ backgroundColor: "#f8fafc" }}>
                <TableCell sx={{ fontWeight: 800 }}>Total preparado</TableCell>
                <TableCell sx={{ ...cellSx, fontWeight: 800 }}>
                  {calculos.amostraTotal > 0 ? "100,0%" : "0,0%"}
                </TableCell>
                <TableCell sx={{ ...cellSx, fontWeight: 800 }}>
                  {formatarCalculo(calculos.granulometriaTresQuartos + calculos.granulometriaNumero4 + calculos.granulometriaPassante, 1)} g
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
      </Box>
    </Stack>
  );
}

function TabelaLimites({
  titulo,
  linhas,
  capsulas,
  tipoCapsula,
  tipoPesoPlasticidade = "tampa",
  onTipoPesoPlasticidadeChange,
  comGolpes = false,
  onChange,
}) {
  const plasticidade = tipoCapsula === "limite_plasticidade";
  const usarCapsulaNaPlasticidade =
    plasticidade && tipoPesoPlasticidade === "capsula";
  const tipoCadastroCapsula = usarCapsulaNaPlasticidade
    ? "limite_liquidez"
    : tipoCapsula;
  const linhasCalculadas = garantirCincoLimites(linhas)
    .map((linha) =>
      plasticidade
        ? normalizarLinhasPlasticidadePorPeso(
            [linha],
            capsulas,
            tipoPesoPlasticidade
          )[0]
        : completarLinhaLimiteComCapsula(linha, capsulas, tipoCapsula)
    )
    .map(calcularLinhaLimiteFisico);


    const indicesPlasticidadeAceitos =
  tipoCapsula === "limite_plasticidade"
    ? obterPlasticidadeAceita(linhasCalculadas).indicesAceitos
    : [];


  function atualizar(index, parcial) {
    const lista = [...linhasCalculadas];
    lista[index] = calcularLinhaLimiteFisico({
      ...lista[index],
      ...parcial,
    });

    onChange(lista);
  }

  function alterarCapsula(index, valorDigitado) {
    const capsula = buscarCapsulaLimitePorNumero(
      capsulas,
      valorDigitado,
      tipoCadastroCapsula
    );
    const peso = pesoCapsulaLimite(capsula, tipoCadastroCapsula);

    atualizar(index, {
      capsula: valorDigitado,
      capsulaNumero: valorDigitado,
      capsulaId: capsula?.id || "",
      pesoCapsula: plasticidade && !usarCapsulaNaPlasticidade ? "" : peso,
      pesoTampa: plasticidade && !usarCapsulaNaPlasticidade ? peso : "",
    });
  }

  const campos = [
    { key: "capsulaNumero", label: "Cápsula Nº", unidade: "" },
    { key: "capsulaSoloAgua", label: "Cáp. + Solo + Água", unidade: "g" },
    { key: "capsulaSolo", label: "Cápsula + Solo", unidade: "g" },
    { key: "agua", label: "Água", unidade: "g", calculado: true },
    {
      key: plasticidade && !usarCapsulaNaPlasticidade ? "pesoTampa" : "pesoCapsula",
      label: plasticidade && !usarCapsulaNaPlasticidade ? "Tampa" : "Cápsula",
      unidade: "g",
      calculado: true,
    },
    { key: "solo", label: "Solo", unidade: "g", calculado: true },
    { key: "umidade", label: "Umidade", unidade: "%", calculado: true },
    ...(comGolpes
      ? [{ key: "numeroGolpes", label: "Nº de GOLPES", unidade: "" }]
      : []),
  ];

  return (
    <Paper
      sx={{
        overflow: "auto",
        border: "1px solid #d7dde8",
        boxShadow: "none",
        borderRadius: "8px",
      }}
    >
      <Table
        size="small"
        sx={{
          width: "100%",
          minWidth: 0,
          tableLayout: "fixed",
          "& td, & th": {
            border: "1px solid #d7dde8",
            fontSize: 11,
            color: "#334155",
            py: "4px",
            px: "3px",
          },
          "& th": {
            backgroundColor: "#fff",
            color: "#0f172a",
          },
          "& .MuiTextField-root": {
            minWidth: 0,
          },
          "& .MuiOutlinedInput-root": {
            minWidth: 0,
            height: 28,
          },
          "& .MuiInputBase-input": {
            minWidth: 0,
            px: "3px",
            fontSize: 11,
          },
        }}
      >
        <colgroup>
          <col style={{ width: 170 }} />
          <col style={{ width: 32 }} />
          {Array.from({ length: 5 }).map((_, index) => (
            <col key={index} style={{ width: 100 }} />
          ))}
        </colgroup>
        <TableBody>
          <TableRow>
            <TableCell
              colSpan={6}
              sx={{
                textAlign: "center",
                fontWeight: 800,
                fontSize: "13px !important",
                backgroundColor: "#fff",
              }}
            >
              {titulo}
            </TableCell>
          </TableRow>

          {campos.map((campo) => (
            <TableRow key={campo.key}>
              <TableCell
                sx={{
                  width: 145,
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                {campo.label}
              </TableCell>

              <TableCell
                sx={{
                  width: 28,
                  textAlign: "center",
                  fontWeight: 700,
                }}
              >
                {campo.unidade}
              </TableCell>

              {linhasCalculadas.map((linha, index) => (
                 <TableCell key={index} sx={{ textAlign: "center" }}>
                  {campo.key === "capsulaNumero" ? (
                    campoTabela(
                      linha.capsulaNumero ?? linha.capsula ?? "",
                      (valor) => alterarCapsula(index, valor),
                      {
                        inputProps: {
                          maxLength: 4,
                          style: {
                            textAlign: "center",
                            fontSize: 12,
                            padding: "3px 4px",
                            height: 16,
                          },
                        },
                      }
                    )
                 ) : campo.calculado ? (
  <Box
    sx={{
      backgroundColor:
        tipoCapsula === "limite_plasticidade" &&
        campo.key === "umidade" &&
        indicesPlasticidadeAceitos.includes(index)
          ? "#c6efce"
          : "transparent",
      color:
        tipoCapsula === "limite_plasticidade" &&
        campo.key === "umidade" &&
        indicesPlasticidadeAceitos.includes(index)
          ? "#006100"
          : "#000",
      fontWeight:
        tipoCapsula === "limite_plasticidade" &&
        campo.key === "umidade" &&
        indicesPlasticidadeAceitos.includes(index)
          ? 800
          : 400,
      py: "2px",
    }}
  >
    {linha[campo.key] || ""}
  </Box>
) : (

                    campoTabela(linha[campo.key], (valor) =>
                      atualizar(index, { [campo.key]: valor })
                    )
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {plasticidade && (
        <Box sx={{ p: 1.25, display: "flex", justifyContent: "flex-end" }}>
          <TextField
            select
            size="small"
            label="Usar peso da"
            value={tipoPesoPlasticidade}
            onChange={(event) =>
              onTipoPesoPlasticidadeChange?.(event.target.value)
            }
            sx={{ width: 180 }}
          >
            <MenuItem value="tampa">Tampa</MenuItem>
            <MenuItem value="capsula">Cápsula</MenuItem>
          </TextField>
        </Box>
      )}
    </Paper>
  );
}

function QuadroResultadosLimites({ resultados }) {
  return (
    <Paper
      sx={{
        overflow: "auto",
        border: "1px solid #d7dde8",
        boxShadow: "none",
        borderRadius: "8px",
      }}
    >
      <Table
        size="small"
        sx={{
          "& td": {
            border: "1px solid #d7dde8",
            fontSize: 11,
            color: "#334155",
            py: "4px",
            px: "3px",
          },
        }}
      >
        <TableBody>
          <TableRow>
            <TableCell
              colSpan={3}
              sx={{ textAlign: "center", fontWeight: 800 }}
            >
              ÍNDICE DE PLASTICIDADE
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Limite de Liquidez</TableCell>
            <TableCell sx={{ textAlign: "center", fontWeight: 700 }}>LL</TableCell>
            <TableCell sx={{ textAlign: "center", fontWeight: 800 }}>
              {resultados.limiteLiquidez || ""}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Limite de Plasticidade</TableCell>
            <TableCell sx={{ textAlign: "center", fontWeight: 700 }}>LP</TableCell>
            <TableCell sx={{ textAlign: "center", fontWeight: 800 }}>
              {resultados.limitePlasticidade || ""}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Índice de Plasticidade</TableCell>
            <TableCell sx={{ textAlign: "center", fontWeight: 700 }}>IP</TableCell>
            <TableCell sx={{ textAlign: "center", fontWeight: 800 }}>
              {resultados.indicePlasticidade || ""}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
}

function QuadroEntradaLimites({ titulo, grupo, dados, campos, onChange }) {
  return (
    <Paper
      sx={{
        overflow: "auto",
        border: "1px solid #d7dde8",
        boxShadow: "none",
        borderRadius: "8px",
      }}
    >
      <Table
        size="small"
        sx={{
          "& td": {
            border: "1px solid #d7dde8",
            fontSize: 11,
            color: "#334155",
            py: "4px",
            px: "3px",
          },
          "& .MuiTextField-root": {
            minWidth: 0,
          },
          "& .MuiOutlinedInput-root": {
            minWidth: 0,
            height: 28,
          },
          "& .MuiInputBase-input": {
            minWidth: 0,
            px: "3px",
            fontSize: 11,
          },
        }}
      >
        <TableBody>
          <TableRow>
            <TableCell
              colSpan={3}
              sx={{ textAlign: "center", fontWeight: 800 }}
            >
              {titulo}
            </TableCell>
          </TableRow>

          {campos.map(([campo, label, unidade]) => (
            <TableRow key={campo}>
              <TableCell sx={{ width: "52%", fontWeight: 600 }}>{label}</TableCell>
              <TableCell sx={{ width: 45, textAlign: "center", fontWeight: 700 }}>
                {unidade || ""}
              </TableCell>
              <TableCell>
                {campoTabela(dados[campo], (valor) =>
                  onChange(grupo, campo, valor)
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

function GraficoLimiteLiquidez({ liquidez, escala = {} }) {
  const dados = garantirCincoLimites(liquidez)
    .map(calcularLinhaLimiteFisico)
    .map((linha) => ({
      golpes: numeroDecimal(linha.numeroGolpes || linha.golpes),
      umidade: numeroDecimal(linha.umidade),
    }))
    .filter((ponto) => ponto.golpes !== null && ponto.golpes > 0 && ponto.umidade !== null)
    .sort((a, b) => a.golpes - b.golpes);

  if (dados.length < 2) {
    return graficoVazio("Informe os pontos do limite de liquidez.");
  }

  const n = dados.length;
  const somaX = dados.reduce((total, p) => total + Math.log10(p.golpes), 0);
  const somaY = dados.reduce((total, p) => total + p.umidade, 0);
  const somaXY = dados.reduce((total, p) => total + Math.log10(p.golpes) * p.umidade, 0);
  const somaX2 = dados.reduce((total, p) => total + Math.log10(p.golpes) ** 2, 0);
  const denominador = n * somaX2 - somaX ** 2;

  if (denominador === 0) {
    return graficoVazio("Não foi possível gerar a reta do limite de liquidez.");
  }

  const a = (n * somaXY - somaX * somaY) / denominador;
  const b = (somaY - a * somaX) / n;

  const ll25 = a * Math.log10(25) + b;

  const width = 520;
  const height = 310;
  const margem = { left: 55, right: 20, top: 28, bottom: 45 };
  const plotW = width - margem.left - margem.right;
  const plotH = height - margem.top - margem.bottom;

  const golpesMinInformado = numeroDecimal(escala.golpesMin);
  const golpesMaxInformado = numeroDecimal(escala.golpesMax);
  const umidadeMinInformada = numeroDecimal(escala.umidadeMin);
  const umidadeMaxInformada = numeroDecimal(escala.umidadeMax);
  const escalaGolpesValida =
    golpesMinInformado !== null && golpesMinInformado > 0 &&
    golpesMaxInformado !== null && golpesMaxInformado > golpesMinInformado;
  const escalaUmidadeValida =
    umidadeMinInformada !== null && umidadeMaxInformada !== null &&
    umidadeMaxInformada > umidadeMinInformada;
  const minGolpes = escalaGolpesValida ? golpesMinInformado : 10;
  const maxGolpes = escalaGolpesValida ? golpesMaxInformado : 50;
  const minY = escalaUmidadeValida ? umidadeMinInformada : 25;
  const maxY = escalaUmidadeValida ? umidadeMaxInformada : 50;
  const criarTicks = (minimo, maximo) =>
    Array.from({ length: 6 }, (_, index) =>
      Number((minimo + ((maximo - minimo) * index) / 5).toFixed(2))
    );
  const ticksGolpes =
    minGolpes === 10 && maxGolpes === 50
      ? [10, 20, 25, 30, 40, 50]
      : criarTicks(minGolpes, maxGolpes);
  const ticksUmidade = criarTicks(minY, maxY);

  const sx = (golpes) =>
    margem.left +
    ((Math.log10(golpes) - Math.log10(minGolpes)) /
      (Math.log10(maxGolpes) - Math.log10(minGolpes))) *
      plotW;

  const sy = (umidade) =>
    margem.top + ((maxY - umidade) / (maxY - minY)) * plotH;

  const yReta = (golpes) => a * Math.log10(golpes) + b;

  const x1 = sx(minGolpes);
  const y1 = sy(yReta(minGolpes));
  const x2 = sx(maxGolpes);
  const y2 = sy(yReta(maxGolpes));
  const x25 = sx(25);
  const y25 = sy(ll25);

  return (
    <Paper sx={{ border: "1px solid #111827", borderRadius: 0, boxShadow: "none", p: 1 }}>
      <Typography sx={{ textAlign: "center", fontWeight: 800, fontSize: 13, mb: 1 }}>
        LIMITE DE LIQUIDEZ
      </Typography>

      <svg viewBox={`0 0 ${width} ${height}`} style={{ width: "100%", height: 310 }}>
        <defs>
          <clipPath id="clip-limite-liquidez-detalhes">
            <rect x={margem.left} y={margem.top} width={plotW} height={plotH} />
          </clipPath>
        </defs>
        {ticksUmidade.map((y) => (
          <g key={y}>
            <line x1={margem.left} x2={width - margem.right} y1={sy(y)} y2={sy(y)} stroke="#111827" strokeWidth="0.8" />
            <text x={margem.left - 10} y={sy(y) + 4} textAnchor="end" fontSize="10">{y}</text>
          </g>
        ))}

        {ticksGolpes.map((x) => (
          <g key={x}>
            <line x1={sx(x)} x2={sx(x)} y1={margem.top} y2={height - margem.bottom} stroke="#111827" strokeWidth="0.8" />
            <text x={sx(x)} y={height - 25} textAnchor="middle" fontSize="10">{x}</text>
          </g>
        ))}

        <line
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke="blue"
          strokeWidth="2"
          clipPath="url(#clip-limite-liquidez-detalhes)"
        />

        <line x1={x25} y1={height - margem.bottom} x2={x25} y2={y25} stroke="red" strokeWidth="2" clipPath="url(#clip-limite-liquidez-detalhes)" />
        <line x1={margem.left} y1={y25} x2={x25} y2={y25} stroke="red" strokeWidth="2" clipPath="url(#clip-limite-liquidez-detalhes)" />

        {dados.map((p, index) => (
          <circle key={index} cx={sx(p.golpes)} cy={sy(p.umidade)} r="3.5" fill="blue" clipPath="url(#clip-limite-liquidez-detalhes)" />
        ))}

        <text x={width / 2} y={height - 5} textAnchor="middle" fontSize="11" fontWeight="700">
          NÚMERO DE GOLPES
        </text>

        <text
          x="14"
          y={height / 2}
          textAnchor="middle"
          fontSize="11"
          fontWeight="700"
          transform={`rotate(-90 14 ${height / 2})`}
        >
          % UMIDADE
        </text>
      </svg>
    </Paper>
  );
}

function GraficoSimples({ titulo, data, dataKey, name, stroke }) {
  return (
    <Paper
      sx={{
        p: 2,
        flex: 1,
        border: "1px solid #d7dde8",
        boxShadow: "none",
      }}
    >
      <Typography fontWeight={700} mb={1}>
        {titulo}
      </Typography>

      {data.length ? (
        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="cilindro" />
            <YAxis />
            <ChartTooltip />
            <Line
              type="monotone"
              dataKey={dataKey}
              name={name}
              stroke={stroke}
              strokeWidth={2}
              dot
            />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        graficoVazio(`Informe os dados de ${titulo}.`)
      )}
    </Paper>
  );
}


